// PharmacistRota.js  (v2 — normalised API)
// Month-by-month pharmacist cover rota across the whole fleet.
//
// REWRITTEN against the headoffice.js v25 normalised API. Nothing is stored
// as one big document any more: pharmacists, cells, logs, settings and
// circulations are separate server collections, and every edit is a small
// atomic POST. Consequences for this component:
//   - loads scale with the visible window, not with history: cells are
//     fetched by date range and refetched only when the window widens
//   - every mutation round-trips a few hundred bytes, so saves stay instant
//     regardless of fleet size or years of data
//   - concurrent editors cannot clobber each other (server uses
//     $addToSet/$pull per cell)
//   - cell change logs and circulation history are fetched lazily, on open
//
// Grid: rows = days of the selected month ("23rd  Tuesday"), columns = every
// pharmacy in the members array (localStorage "members"). Open/closed per day
// comes from each member's openingTimes (closed = missing day or open === close).
//
// Cell colours:
//   pale grey  — pharmacy closed that day
//   mid green  — open + covered by at least one non-locum (names shown)
//   pale green — open + covered by locum(s) only
//   red        — open + not covered
//
// PERMANENT (WEEKLY) ASSIGNMENTS — PROVISIONAL MODEL (v3):
// Patterns are no longer virtual. Each month is POPULATED exactly once,
// server-side (POST /rota/materialise, ledgered per org+month): every
// pattern placement becomes a stored PROVISIONAL entry in rota_cells. So
// every visible placement has a real database row from the start, and can
// be edited one by one. Provisional entries render HATCHED; DOUBLE-CLICK a
// cell (or use the Confirm buttons in its popup) to confirm them.
// Pattern changes LIVE-SYNC the unconfirmed layer (v4): editing a
// pharmacist's permanent days moves/adds/removes their PROVISIONAL entries
// from today through the populated horizon — confirmed entries are never
// touched, and double-bookings are skipped. A provisional entry removed by
// hand still never comes back by itself. Navigation and population are
// capped at 6 months ahead of today.
//
// CONFIRM ALL (v5): the toolbar "Confirm all" button confirms every
// unconfirmed placement in the visible month — equivalent to double-
// clicking each hatched cell — then refetches the grid.
//
// DAY-LABEL STATUS (v5): each date label is coloured — RED if the same
// pharmacist is at 2+ open sites that day, AMBER if any open site has no
// cover, GREEN if all open sites are covered by distinct pharmacists.
// Today keeps a blue inset outline.
//
// EMAIL SCHEDULES NOW (v7): opens a dialogue — all pharmacists listed with
// checkboxes (ticked by default), a weeks-ahead selector, and an "include
// the current week" option. Send shows a confirmation stating exactly how
// many emails will go out, then sends one personalised schedule per
// pharmacist via POST /circulate.
//
// EMAIL HISTORY (v7): toolbar button opening a dialogue over the unified
// rota_email_logs collection (GET /rota/emails) — every email the rota has
// sent from ANY source (circulations, schedules, booking confirmations,
// weekly auto emails, cover reports), with date, recipient, status and full
// body. Requires headoffice.js v27 + jobs.js v21 which write the rows.
//
// LOCUM PAY (v5/v7): pharmacist register stores hourlyRate (locums only) —
// persisting requires headoffice.js v27 (older builds silently dropped the
// field). Monthly payment schedules add an "Hours on site" column derived
// from each pharmacy's openingTimes in the members array, amount = hours ×
// rate, with a computed grand total. Downloaded locally — never emailed.
//
// UNCOVERED LIST (v7): each unfilled session row has an Assign button that
// opens the standard cell dialogue (replacing the old locum-only dropdown).
//
// ACTIVE FLAG: inactive pharmacists are hidden from pick lists, not applied
// via patterns, and excluded from circulations. Existing explicit
// assignments remain visible.
//
// SERVER API (all mutations POST — the production IIS/Plesk host blocks
// PUT/DELETE at the web-server layer):
//   GET  /api/headoffice/rota/pharmacists
//   POST /api/headoffice/rota/pharmacists                     { pharmacist }
//   POST /api/headoffice/rota/pharmacists/:id/update          { pharmacist }
//   POST /api/headoffice/rota/pharmacists/:id/delete
//   GET  /api/headoffice/rota/cells?from&to
//   POST /api/headoffice/rota/cells/mutate  { date, pharmacyName,
//        pharmacyId, pharmacistId, action: add|remove|confirm, logDetail }
//        (v29: on the first add/confirm the server stores the pharmacy's
//        opening shifts for that day on the cell and returns the cell)
//   POST /api/headoffice/rota/cells/shifts   { date, pharmacyName,
//        shifts: [{ start, end }] }   (v29 — manual shift edits)
//   POST /api/headoffice/rota/materialise    { monthKeys: ['YYYY-MM'] }
//   GET  /api/headoffice/rota/logs?cellKey
//   GET  /api/headoffice/rota/settings
//   POST /api/headoffice/rota/settings/save   { settings: { autoEmailWeekly,
//        coverFailureEmail } }  (both weekly emails run Thursdays for the
//        FOLLOWING week(s) — see jobs.js v20)
//   GET  /api/headoffice/rota/circulations
//   POST /api/headoffice/rota/circulate     { subject, messages }
//
// CONTRACTED HOURS FROM pharmace_common_db (v33): on a swap day the hours
// the pharmacist was SUPPOSED to work are read straight from
// pharmace_common_db.pharmacies.openingHours for their SCHEDULED site —
// fetched in batch via POST /rota/opening-hours (headoffice.js v31) and
// cached per (date, site). The scheduled site's cell shifts and the
// members-array openingTimes are no longer consulted for the contracted
// side. found:false (pharmacy unmatched) → manual review; hours 0 (site
// closed that day) → the whole worked session nets as extra. WORKED hours
// are unchanged: the stored shifts on the worked cell, manager-editable.
//
// SWAP HANDLING (v32): in the additional-sessions run, a non-locum working
// at a DIFFERENT site from their weeklyPattern site that day is a SWAP,
// not automatically an extra session. Worked hours (stored shifts on the
// worked cell) are compared with CONTRACTED hours at the scheduled site
// (v33: from pharmace_common_db.pharmacies opening hours):
//   equal   → EXCLUDED from the schedule; an explanatory entry is written
//             to the cell's log (why it is not treated as locum/extra pay)
//   greater → the DIFFERENCE (+hrs) goes on the schedule
//   less    → a NEGATIVE difference goes on the schedule
//   unknown → row included with blank figures, flagged for manual review
// Every swap row carries a NARRATIVE column (right of the figures) in the
// spreadsheet and Word doc explaining contracted X vs worked Y, and the
// same narrative is written to the cell's change log (idempotently, via
// POST /rota/logs/annotate — headoffice.js v30; duplicates are skipped).
// Plain extra sessions (no pattern site that day) are unchanged and carry
// the narrative 'Additional session — not scheduled to work this day'.
// jobs.js v24 mirrors all of this in the monthly email.
//
// NO FALLBACK HOURS (v31): hours on site come ONLY from the shifts stored
// on the cell (captured from pharmace_common_db.pharmacies at booking, or
// entered by hand). If a session has no stored shifts its hours, times and
// amount are left EMPTY in every document and spreadsheet — no fallback to
// the members-array opening times, no zeros. Totals sum recorded sessions
// only, with a footnote stating how many sessions had no recorded hours.
//
// ADDITIONAL-SESSIONS RUN (v31): the payment summaries dialogue produces a
// SECOND run alongside the locum one — pharmacists whose type is NOT
// 'Locum' (full-time / part-time), including ONLY their EXTRA sessions:
// cells in the month where their permanent weeklyPattern for that day of
// the week is NOT that pharmacy (i.e. their normal scheduled cells are
// excluded). Hours come from the same stored shifts and pay uses the same
// hourlyRate field, which is now editable for EVERY pharmacist type in the
// register (not just locums). Word docs are titled 'Additional Sessions
// Payment Schedule'; per-branch workbooks are named
// Additional_sessions_payment_schedules_<Branch>_<YYYY-MM>.xlsx.
// jobs.js v23 mirrors both runs in the monthly manager email.
//
// CELL DIALOGUE REDESIGN (v30): the cell popup is much wider (1080px) and
// split into TWO PANELS — LEFT: "This session" (current pharmacist, the
// hours-on-site editor and buttons, notes beneath); RIGHT: "Assign / change
// pharmacist" (+ New pharmacist and the click-to-assign pick list, which
// scrolls vertically for long registers). Pharmacists who CANNOT take the
// session (red — already at another site that date) always sort to the END
// of the list. The change log moved out of the body into a "View log"
// button (top right) opening its own popup with a Close button.
//
// XLSX COLUMN WIDTHS (v30): the workbook writer now emits per-column
// widths sized to the widest cell in each column (clamped 9–60 Excel
// character units), so dates, shift times and locum names no longer
// truncate. Mirrored in jobs.js v22 for the monthly email job.
//
// PER-CELL STORED SHIFTS (v29): the FIRST time a cell gains real cover —
// either a provisional entry being CONFIRMED or a pharmacist being ADDED —
// the server looks up that pharmacy's opening hours for that day of the
// week in pharmace_common_db.pharmacies (openingHours[].slots, which may
// hold one, two or more start/end pairs) and stores them ON THE CELL as
// shifts: [{ start:"HH:MM", end:"HH:MM" }]. The cell popup displays the
// stored shifts and lets the user EDIT them (add/remove/adjust pairs —
// e.g. the pharmacist arrived late), saved via POST /rota/cells/shifts.
// Locum payment calculations use the STORED shifts (all pairs summed) as
// the hours-on-site source; cells with no stored shifts (booked before
// v29) fall back to the members-array opening times as before.
// Requires headoffice.js v29 (mutate stores shifts on first population,
// /cells returns them, /cells/shifts saves manual edits).
//
// LOCUM PAYMENT SPREADSHEETS PER BRANCH (v29): the tabbed workbook is now
// generated ONE PER BRANCH (pharmacy) rather than one per organisation —
// each branch workbook has a Summary tab then one tab per locum covering
// only that branch's sessions. Only pharmacists of type "Locum" are ever
// included in payment schedules.
//
// There is NO localStorage persistence (any legacy "pharmacist_rota_doc"
// key is purged on load). If the backend is unreachable the page shows a
// hard error with the HTTP detail.

import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useMaskNames, displayName } from "./nameMask";

const API_BASE = "https://api.pharmacegroup.co.uk";
const LEGACY_LS_KEY = "pharmacist_rota_doc"; // purged on load, never written
const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const WEEK_ORDER = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
const SESSIONS_TOKEN = "{SESSIONS}";

/* ------------------------------------------------------------------ */
/* Date / misc helpers                                                 */
/* ------------------------------------------------------------------ */

function ordinal(n) {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function ymd(d) {
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

function prettyDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return `${DAY_NAMES[d.getDay()].slice(0, 3)} ${ordinal(d.getDate())} ${MONTH_NAMES[d.getMonth()].slice(0, 3)} ${d.getFullYear()}`;
}

function dowOf(dateStr) {
  return DAY_NAMES[new Date(dateStr + "T00:00:00").getDay()];
}

function cellKey(dateStr, pharmacyName) {
  return `${dateStr}|${pharmacyName}`;
}

function isOpen(member, dateStr) {
  const times = member.openingTimes?.[dowOf(dateStr)];
  if (!times || !times.open || !times.close) return false;
  return times.open !== times.close;
}
// (v31: the old hoursOpen() fallback — hours from the members-array
// opening times — is REMOVED. Hours come only from stored cell shifts.)

/* ---- per-cell stored shifts (v29, fallback removed v31) ------------ */
// shifts: [{ start:"HH:MM", end:"HH:MM" }] — one, two or more pairs per
// day (split-day opening). Stored ON the cell when it is first populated
// (server-side, from pharmace_common_db.pharmacies openingHours), then
// user-editable per session. Payment hours = sum of all valid pairs.
// v31: there is NO fallback — a session with no stored shifts has NO
// hours (null), and its hours/amount stay EMPTY in every document.

function shiftMins(s) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(s || "").trim());
  if (!m) return null;
  const h = Number(m[1]), mi = Number(m[2]);
  if (h > 23 || mi > 59) return null;
  return h * 60 + mi;
}

// Total hours across every valid shift pair, to 2 dp.
function shiftsHours(shifts) {
  if (!Array.isArray(shifts)) return 0;
  let mins = 0;
  shifts.forEach(sh => {
    const a = shiftMins(sh?.start), b = shiftMins(sh?.end);
    if (a !== null && b !== null && b > a) mins += b - a;
  });
  return Math.round((mins / 60) * 100) / 100;
}

// "09:00–13:00, 14:00–17:00"
function fmtShifts(shifts) {
  if (!Array.isArray(shifts)) return "";
  return shifts
    .filter(sh => shiftMins(sh?.start) !== null && shiftMins(sh?.end) !== null)
    .map(sh => `${sh.start}–${sh.end}`)
    .join(", ");
}

// Hours-on-site for one session: the cell's STORED shifts when present
// (set on first population, user-editable), otherwise NULL (v31 — the
// session's hours and amount are omitted; no fallback calculation).
function sessionHours(cells, member, dateStr) {
  const cell = cells.get(cellKey(dateStr, member.pharmacyName));
  if (cell && Array.isArray(cell.shifts) && cell.shifts.length)
    return shiftsHours(cell.shifts);
  return null;
}

// Human-readable times for one session ("" when no shifts are stored).
function sessionTimes(cells, member, dateStr) {
  const cell = cells.get(cellKey(dateStr, member.pharmacyName));
  if (cell && Array.isArray(cell.shifts) && cell.shifts.length)
    return fmtShifts(cell.shifts);
  return "";
}

// v31: was this session part of the pharmacist's PERMANENT weekly
// schedule? True when their weeklyPattern for that day of the week is
// exactly this pharmacy. Used by the additional-sessions run to EXCLUDE
// normal scheduled cells so only extra sessions are paid.
function isPatternSession(pharmacist, dateStr, pharmacyName) {
  return ((pharmacist.weeklyPattern || {})[dowOf(dateStr)] || "") === pharmacyName;
}

// v33: CONTRACTED hours on a swap day come ONLY from
// pharmace_common_db.pharmacies.openingHours for the SCHEDULED site — the
// frontend fetches them in batch via POST /rota/opening-hours
// (headoffice.js v31) and caches per (date, site). Neither the scheduled
// site's cell shifts nor the members-array openingTimes are consulted.

function emptyPattern() {
  return Object.fromEntries(WEEK_ORDER.map(d => [d, ""]));
}

function addDays(dateStr, n) {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + n);
  return ymd(d);
}

function addMonths(dateStr, n) {
  const d = new Date(dateStr + "T00:00:00");
  d.setMonth(d.getMonth() + n);
  return ymd(d);
}

/* ------------------------------------------------------------------ */
/* API layer — thin fetch helpers with actionable error detail         */
/* ------------------------------------------------------------------ */

function httpHint(status) {
  if (status === 413) return " — server JSON body limit too small; set app.use(express.json({ limit: '10mb' })) in server.js";
  if (status === 404) return " — rota endpoints missing; deploy headoffice.js v25 and restart the server";
  if (status === 401 || status === 403) return " — auth rejected; token missing/expired or JWT middleware not passing req.user";
  return "";
}

async function api(method, path, body) {
  const token = localStorage.getItem("authToken") || "";
  try {
    const opts = { method, headers: { Authorization: `Bearer ${token}` } };
    if (body !== undefined) {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    const res = await fetch(`${API_BASE}/api/headoffice/rota${path}`, opts);
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      return { ok: false, status: res.status, error: `${method} /rota${path} → HTTP ${res.status} ${text.slice(0, 160)}${httpHint(res.status)}` };
    }
    return { ok: true, data: await res.json() };
  } catch (e) {
    return { ok: false, error: `${method} /rota${path} → network error: ${e.message}` };
  }
}

const apiGet = (path) => api("GET", path);
const apiPost = (path, body) => api("POST", path, body);

/* ------------------------------------------------------------------ */
/* Cell entries — stored-only model (v3)                               */
/* ------------------------------------------------------------------ */
// cells: Map(cellKey -> { assigned: [pid], provisional: [pid] })
// assigned = confirmed. Returns [{ pid, status }] for one cell.
function cellEntries(cells, member, dateStr) {
  const cell = cells.get(cellKey(dateStr, member.pharmacyName));
  if (!cell) return [];
  return [
    ...(cell.assigned || []).map(pid => ({ pid, status: "confirmed" })),
    ...(cell.provisional || []).map(pid => ({ pid, status: "provisional" }))
  ];
}

// Set of dates in [start, end] on which a pharmacist works ANYWHERE
// (confirmed or provisional — a provisional placement still occupies them).
function busyDates(cells, pid, start, end) {
  const busy = new Set();
  cells.forEach((cell, key) => {
    const [date] = key.split("|");
    if (date < start || date > end) return;
    if ((cell.assigned || []).includes(pid) || (cell.provisional || []).includes(pid)) busy.add(date);
  });
  return busy;
}

/* ------------------------------------------------------------------ */
/* Word document (payment schedule) — Word-compatible HTML .doc blob   */
/* ------------------------------------------------------------------ */

function escapeHtml(s) {
  return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// sessions: [{ date, pharmacy, status, hours, times, narrative? }] — hours
// come ONLY from the cell's STORED shifts. v31: hours may be NULL (not
// recorded) — that row's times, hours and amount are left EMPTY, and
// totals sum recorded sessions only. v32 (additional run): hours may be a
// signed DIFFERENCE for swaps (worked minus contracted, can be negative),
// and each row's NARRATIVE column (right of the figures) explains it.
// rate: the pharmacist's hourlyRate (number or "").
// kind: "locum" (default) or "additional" — the additional run covers
// NON-locum pharmacists' out-of-schedule work and adds the Narrative
// column, headings and footnotes.
// These documents are DOWNLOADED ONLY (never emailed) so the manager can
// review and amend before payment.
function buildPaymentScheduleDoc(person, sessions, monthLabel, kind = "locum") {
  const rate = Number(person.hourlyRate);
  const hasRate = Number.isFinite(rate) && rate > 0;
  const money = (n) => n.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const additional = kind === "additional";
  const title = additional ? "Additional Sessions Payment Schedule" : "Locum Payment Schedule";
  const personLabel = additional ? `Pharmacist (${escapeHtml(person.type || "")})` : "Locum pharmacist";
  const td = (inner, align) => `<td style="border:1px solid #999;padding:6px 10px;${align === "r" ? "text-align:right;" : ""}">${inner}</td>`;
  const th = (inner, align) => `<th style="border:1px solid #999;padding:6px 10px;background:#f3f4f6;text-align:${align === "r" ? "right" : "left"};">${inner}</th>`;

  let totalHours = 0, totalAmount = 0, unrecorded = 0;
  const rows = sessions.map(s => {
    const hasHours = s.hours !== null && s.hours !== undefined && Number.isFinite(Number(s.hours));
    const hours = hasHours ? Number(s.hours) : null;
    if (hasHours) totalHours += hours; else unrecorded++;
    const amount = hasHours && hasRate ? hours * rate : null;
    if (amount !== null) totalAmount += amount;
    return `
    <tr>
      ${td(escapeHtml(prettyDate(s.date)))}
      ${td(escapeHtml(s.pharmacy) + (s.status === "provisional" ? " (UNCONFIRMED)" : ""))}
      ${td(s.times ? escapeHtml(s.times) : "&nbsp;")}
      ${td(hasHours ? hours.toFixed(2) : "&nbsp;", "r")}
      ${td(hasHours && hasRate ? money(rate) : "&nbsp;", "r")}
      ${td(amount !== null ? money(amount) : "&nbsp;", "r")}
      ${additional ? td(s.narrative ? escapeHtml(s.narrative) : "&nbsp;") : ""}
    </tr>`;
  }).join("");

  return `
<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="utf-8"><title>${title}</title>
<!--[if gte mso 9]><xml><w:WordDocument><w:View>Print</w:View></w:WordDocument></xml><![endif]-->
<style>body{font-family:Calibri,Arial,sans-serif;font-size:11pt;color:#1f2937;}
h1{font-size:16pt;} table{border-collapse:collapse;width:100%;}</style>
</head><body>
<h1>${title} — ${escapeHtml(monthLabel)}</h1>
<p><b>${personLabel}:</b> ${escapeHtml(person.name)}<br/>
<b>GPhC number:</b> ${escapeHtml(person.gphc || "—")}<br/>
<b>Email:</b> ${escapeHtml(person.email || "—")}<br/>
<b>Mobile:</b> ${escapeHtml(person.mobile || "—")}<br/>
<b>Address:</b> ${escapeHtml(person.address || "—")}<br/>
<b>Hourly rate:</b> ${hasRate ? "&pound;" + money(rate) : "&mdash; not set (add it in the pharmacist register)"}</p>
${additional ? `<p style="font-size:10pt;color:#374151;">Only work <b>outside this pharmacist's permanent weekly schedule</b> is included. Day SWAPS are netted: equal-hours swaps are excluded entirely (see the cell's change log); unequal swaps appear as the signed DIFFERENCE between worked and contracted hours (a negative figure is a deduction) — the Narrative column explains each row.</p>` : ""}
<p><b>Sessions ${additional ? "(additional)" : "worked"}: ${sessions.length}</b> &nbsp;·&nbsp; <b>Total recorded hours: ${totalHours.toFixed(2)}</b>${unrecorded ? ` &nbsp;·&nbsp; <b style="color:#92400e;">${unrecorded} session${unrecorded === 1 ? "" : "s"} with no recorded hours</b>` : ""}</p>
<table>
  <tr>
    ${th("Date")}
    ${th("Pharmacy")}
    ${th("Times on site")}
    ${th("Hours", "r")}
    ${th("Rate (&pound;/hr)", "r")}
    ${th("Amount (&pound;)", "r")}
    ${additional ? th("Narrative") : ""}
  </tr>
  ${rows}
  <tr>
    <td colspan="3" style="border:1px solid #999;padding:6px 10px;text-align:right;"><b>Total (recorded sessions)</b></td>
    <td style="border:1px solid #999;padding:6px 10px;text-align:right;"><b>${totalHours.toFixed(2)}</b></td>
    <td style="border:1px solid #999;padding:6px 10px;">&nbsp;</td>
    <td style="border:1px solid #999;padding:6px 10px;text-align:right;"><b>${hasRate ? money(totalAmount) : "&nbsp;"}</b></td>
    ${additional ? `<td style="border:1px solid #999;padding:6px 10px;">&nbsp;</td>` : ""}
  </tr>
</table>
<p style="margin-top:12px;font-size:9pt;color:#6b7280;">
Hours are the shift times recorded on each session (captured from the pharmacy's opening
hours when the session was booked, and editable per session in the rota), summed across all
shifts that day. Sessions with no recorded times have their times, hours and amount left
blank for manual completion — open the session in the rota and add its shifts to record them.
${hasRate ? "" : `No hourly rate is recorded for this ${additional ? "pharmacist" : "locum"}, so rate and amount columns are left blank for manual completion.`}</p>
<p style="margin-top:8px;font-size:9pt;color:#6b7280;">
Generated ${escapeHtml(new Date().toLocaleString("en-GB"))} — for review and amendment prior to payment.</p>
</body></html>`;
}
function downloadDoc(filename, html) {
  const blob = new Blob(["\ufeff", html], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/* ------------------------------------------------------------------ */
/* Minimal XLSX writer (v28) — dependency-free. Builds a real .xlsx    */
/* (a ZIP of OOXML parts) with STORED zip entries and inline strings.  */
/* Mirrors the identical builder in jobs.js (monthly email job).       */
/* ------------------------------------------------------------------ */

const XLSX_CRC_TABLE = (() => {
  const t = new Int32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
    t[n] = c;
  }
  return t;
})();
function xlsxCrc32(buf) {
  let c = 0 ^ (-1);
  for (let i = 0; i < buf.length; i++) c = (c >>> 8) ^ XLSX_CRC_TABLE[(c ^ buf[i]) & 0xFF];
  return (c ^ (-1)) >>> 0;
}
function xlsxEsc(s) {
  return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
// Per-column widths from the widest cell in each column (v30): Excel width
// units are roughly characters, so widest content + padding, clamped 9–60
// so a long note can't produce an absurd column.
function xlsxColWidths(rows) {
  const w = [];
  rows.forEach(row => row.forEach((v, ci) => {
    if (v === null || v === undefined || v === "") return;
    const len = String(v).length;
    if (!w[ci] || len > w[ci]) w[ci] = len;
  }));
  return w.map(len => Math.min(60, Math.max(9, (len || 0) + 2)));
}
function xlsxSheetXml(rows) {
  const colL = (i) => {
    let s = ""; i++;
    while (i > 0) { const m = (i - 1) % 26; s = String.fromCharCode(65 + m) + s; i = Math.floor((i - 1) / 26); }
    return s;
  };
  const widths = xlsxColWidths(rows);
  const cols = widths.length
    ? `<cols>` + widths.map((wd, i) => `<col min="${i + 1}" max="${i + 1}" width="${wd}" customWidth="1"/>`).join("") + `</cols>`
    : "";
  const body = rows.map((row, ri) =>
    `<row r="${ri + 1}">` + row.map((v, ci) => {
      if (v === null || v === undefined || v === "") return "";
      const r = `${colL(ci)}${ri + 1}`;
      if (typeof v === "number" && Number.isFinite(v)) return `<c r="${r}"><v>${v}</v></c>`;
      return `<c r="${r}" t="inlineStr"><is><t xml:space="preserve">${xlsxEsc(v)}</t></is></c>`;
    }).join("") + `</row>`
  ).join("");
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">${cols}<sheetData>${body}</sheetData></worksheet>`;
}
// sheets: [{ name, rows }] where each cell is a number or string.
function buildXlsx(sheets) {
  const used = new Set();
  const safeName = (n, i) => {
    let s = String(n || `Sheet${i + 1}`).replace(/[\\/[\]*?:]/g, " ").trim().slice(0, 31) || `Sheet${i + 1}`;
    let out = s, k = 2;
    while (used.has(out.toLowerCase())) out = `${s.slice(0, 28)} ${k++}`;
    used.add(out.toLowerCase());
    return out;
  };
  const names = sheets.map((s, i) => safeName(s.name, i));

  const files = [];
  files.push(["[Content_Types].xml",
    `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">` +
    `<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>` +
    `<Default Extension="xml" ContentType="application/xml"/>` +
    `<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>` +
    sheets.map((_, i) => `<Override PartName="/xl/worksheets/sheet${i + 1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join("") +
    `<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>` +
    `</Types>`]);
  files.push(["_rels/.rels",
    `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">` +
    `<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>` +
    `</Relationships>`]);
  files.push(["xl/workbook.xml",
    `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>` +
    names.map((n, i) => `<sheet name="${xlsxEsc(n)}" sheetId="${i + 1}" r:id="rId${i + 1}"/>`).join("") +
    `</sheets></workbook>`]);
  files.push(["xl/_rels/workbook.xml.rels",
    `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">` +
    sheets.map((_, i) => `<Relationship Id="rId${i + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${i + 1}.xml"/>`).join("") +
    `<Relationship Id="rId${sheets.length + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>` +
    `</Relationships>`]);
  files.push(["xl/styles.xml",
    `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
    `<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">` +
    `<fonts count="1"><font><sz val="11"/><name val="Calibri"/></font></fonts>` +
    `<fills count="1"><fill><patternFill patternType="none"/></fill></fills>` +
    `<borders count="1"><border/></borders>` +
    `<cellStyleXfs count="1"><xf/></cellStyleXfs>` +
    `<cellXfs count="1"><xf/></cellXfs>` +
    `<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>` +
    `</styleSheet>`]);
  sheets.forEach((s, i) => files.push([`xl/worksheets/sheet${i + 1}.xml`, xlsxSheetXml(s.rows)]));

  // ---- stored-entry ZIP ----
  const enc = new TextEncoder();
  const parts = [], central = [];
  let offset = 0;
  const le16 = (n) => new Uint8Array([n & 0xFF, (n >> 8) & 0xFF]);
  const le32 = (n) => new Uint8Array([n & 0xFF, (n >> 8) & 0xFF, (n >> 16) & 0xFF, (n >> 24) & 0xFF]);
  const cat = (arrs) => {
    const total = arrs.reduce((a, x) => a + x.length, 0);
    const out = new Uint8Array(total);
    let o = 0;
    arrs.forEach(x => { out.set(x, o); o += x.length; });
    return out;
  };
  for (const [name, xml] of files) {
    const nameBuf = enc.encode(name);
    const data = enc.encode(xml);
    const crc = xlsxCrc32(data);
    const local = cat([
      le32(0x04034b50), le16(20), le16(0), le16(0), le16(0), le16(0x21),
      le32(crc), le32(data.length), le32(data.length),
      le16(nameBuf.length), le16(0), nameBuf, data
    ]);
    central.push(cat([
      le32(0x02014b50), le16(20), le16(20), le16(0), le16(0), le16(0), le16(0x21),
      le32(crc), le32(data.length), le32(data.length),
      le16(nameBuf.length), le16(0), le16(0), le16(0), le16(0), le32(0), le32(offset),
      nameBuf
    ]));
    parts.push(local);
    offset += local.length;
  }
  const centralBuf = cat(central);
  const eocd = cat([
    le32(0x06054b50), le16(0), le16(0), le16(files.length), le16(files.length),
    le32(centralBuf.length), le32(offset), le16(0)
  ]);
  return cat([...parts, centralBuf, eocd]);
}

function downloadXlsx(filename, sheets) {
  const bytes = buildXlsx(sheets);
  const blob = new Blob([bytes], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/* ------------------------------------------------------------------ */
/* Style tokens — matches HeadOffice.js / Config.js conventions        */
/* ------------------------------------------------------------------ */

const S = {
  wrap: { padding: 16, fontFamily: "system-ui, sans-serif", background: "#fef3c7", minHeight: "100vh", boxSizing: "border-box" }, // pale amber — beta flag
  h1: { fontSize: 22, fontWeight: 600, margin: 0 },
  headRow: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" },
  toolbar: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 12 },
  panel: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, marginBottom: 12 },
  btn: { background: "#2563eb", color: "#fff", border: "none", borderRadius: 4, padding: "6px 12px", cursor: "pointer", fontSize: 13 },
  btnGhost: { background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", borderRadius: 4, padding: "6px 12px", cursor: "pointer", fontSize: 13 },
  btnGreen: { background: "#059669", color: "#fff", border: "none", borderRadius: 4, padding: "6px 12px", cursor: "pointer", fontSize: 13 },
  btnDanger: { background: "#dc2626", color: "#fff", border: "none", borderRadius: 4, padding: "4px 8px", cursor: "pointer", fontSize: 12 },
  select: { padding: "5px 8px", border: "1px solid #d1d5db", borderRadius: 4, fontSize: 13 },
  input: { padding: "5px 8px", border: "1px solid #d1d5db", borderRadius: 4, fontSize: 13 },
  gridWrap: { overflow: "auto", maxHeight: "70vh", border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff" },
  table: { borderCollapse: "separate", borderSpacing: 0, fontSize: 12 },
  thPharm: {
    position: "sticky", top: 0, zIndex: 3, background: "#f9fafb", borderBottom: "2px solid #d1d5db",
    borderRight: "1px solid #e5e7eb", padding: "8px 6px", fontWeight: 600, color: "#374151",
    minWidth: 120, maxWidth: 140, whiteSpace: "normal", verticalAlign: "bottom", textAlign: "left"
  },
  thDay: {
    position: "sticky", left: 0, zIndex: 2, background: "#f9fafb", borderRight: "2px solid #d1d5db",
    borderBottom: "1px solid #e5e7eb", padding: "6px 10px", fontWeight: 600, color: "#374151",
    whiteSpace: "nowrap", textAlign: "left", minWidth: 130
  },
  cellBase: {
    position: "relative",
    borderRight: "1px solid #e5e7eb", borderBottom: "1px solid #e5e7eb",
    padding: "4px 6px 4px 12px", minWidth: 120, maxWidth: 140, verticalAlign: "top", cursor: "pointer"
  },
  provMark: {
    position: "absolute", top: 1, left: 2, fontSize: 9, fontWeight: 700,
    color: "#92400e", lineHeight: 1
  },
  overlay: {
    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
    background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center",
    alignItems: "flex-start", zIndex: 1000, overflowY: "auto"
  },
  modal: {
    background: "#fff", borderRadius: 8, padding: 20, marginTop: 40, marginBottom: 40,
    maxWidth: "94vw", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
  },
  modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, gap: 20 },
  modalTitle: { fontSize: 17, fontWeight: 600, margin: 0 },
  small: { fontSize: 12, color: "#6b7280" },
  tag: { display: "inline-block", padding: "1px 6px", borderRadius: 3, fontSize: 11, marginLeft: 6 },
  logRow: { borderBottom: "1px solid #f3f4f6", padding: "6px 0", fontSize: 12 },
  toast: { position: "fixed", bottom: 20, right: 20, background: "#1f2937", color: "#fff", padding: "10px 14px", borderRadius: 4, fontSize: 13, zIndex: 2000 }
};

const CELL_COLOURS = {
  closed: "#f3f4f6",     // pale grey
  covered: "#6ee7b7",    // mid green (non-locum present)
  locumOnly: "#d1fae5",  // pale green (locum(s) only)
  uncovered: "#fee2e2"   // pale red (uncovered / no pharmacist assigned)
};

// Hatched (diagonal-striped) background for cells whose cover is still
// provisional — unmistakably different from confirmed cover.
function hatched(colour) {
  return `repeating-linear-gradient(45deg, ${colour}, ${colour} 6px, rgba(255,255,255,0.65) 6px, rgba(255,255,255,0.65) 10px)`;
}

/* ------------------------------------------------------------------ */
/* Pharmacist add/edit mini-form                                       */
/* ------------------------------------------------------------------ */

function PharmacistForm({ initial, onSave, onCancel, busy }) {
  const [f, setF] = useState(initial ? { hourlyRate: "", ...initial } : {
    name: "", gphc: "", mobile: "", email: "", address: "",
    type: "Locum", active: true, weeklyPattern: emptyPattern(), hourlyRate: ""
  });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const ok = f.name.trim().length > 0 && !busy;
  return (
    <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 6, padding: 10, marginTop: 8 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <input style={S.input} placeholder="Name *" value={f.name} onChange={set("name")} />
        <input style={S.input} placeholder="GPhC number" value={f.gphc} onChange={set("gphc")} />
        <input style={S.input} placeholder="Mobile" value={f.mobile} onChange={set("mobile")} />
        <input style={S.input} placeholder="Email" value={f.email} onChange={set("email")} />
        <input style={{ ...S.input, gridColumn: "1 / span 2" }} placeholder="Address" value={f.address} onChange={set("address")} />
        <select style={S.select} value={f.type} onChange={set("type")}>
          <option>Full-time</option><option>Part-time</option><option>Locum</option>
        </select>
        <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
          <input type="checkbox" checked={f.active !== false}
            onChange={e => setF({ ...f, active: e.target.checked })} /> Active
        </label>
        <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, gridColumn: "1 / span 2" }}
          title="Used on the downloaded monthly payment schedules: amount per session = hours on site (the shift times recorded on the session, all shifts summed) × this rate. Applies to the locum payment run AND, for full/part-time pharmacists, the additional-sessions run.">
          Hourly pay rate (£/hr)
          <input style={{ ...S.input, width: 110 }} type="number" min="0" step="0.50"
            placeholder="e.g. 32.50" value={f.hourlyRate ?? ""} onChange={set("hourlyRate")} />
          <span style={S.small}>{f.type === "Locum" ? "used for the monthly locum payment schedules" : "used for the additional-sessions payment schedules"}</span>
        </label>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", gridColumn: "1 / span 2" }}>
          <button style={S.btnGhost} onClick={onCancel}>Cancel</button>
          <button style={{ ...S.btnGreen, opacity: ok ? 1 : 0.5 }} disabled={!ok}
            onClick={() => onSave({
              ...f, name: f.name.trim(),
              hourlyRate: f.hourlyRate === "" || f.hourlyRate === null || f.hourlyRate === undefined
                ? "" : Number(f.hourlyRate)
            })}>{busy ? "Saving…" : "Save pharmacist"}</button>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Weekly permanent-assignment editor (Mon–Sun pharmacy dropdowns)     */
/* ------------------------------------------------------------------ */

function WeeklyPatternEditor({ pharmacist, members, updatePharmacist }) {
  const masked = useMaskNames();
  const setDay = (day, pharmacyName) => {
    const weeklyPattern = { ...emptyPattern(), ...(pharmacist.weeklyPattern || {}), [day]: pharmacyName };
    updatePharmacist(pharmacist.id, { weeklyPattern });
  };
  return (
    <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, padding: 10 }}>
      <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>
        Permanent weekly assignment — {displayName(pharmacist.name, masked)}
        <span style={{ ...S.small, marginLeft: 8 }}>
          Changes apply from TODAY onwards: unconfirmed (hatched) placements are
          moved/added/removed to match — confirmed entries are never touched, and
          dates where the pharmacist already works elsewhere are skipped.
        </span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 8 }}>
        {WEEK_ORDER.map(day => (
          <label key={day} style={{ fontSize: 12, display: "flex", flexDirection: "column", gap: 3 }}>
            <b>{day}</b>
            <select style={S.select} value={pharmacist.weeklyPattern?.[day] || ""}
              onChange={e => setDay(day, e.target.value)}>
              <option value="">— none —</option>
              {members.map(m => <option key={m.pharmacyName} value={m.pharmacyName}>{displayName(m.pharmacyName, masked)}</option>)}
            </select>
          </label>
        ))}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Cell popup — CLICK-TO-ASSIGN list (v6) + change log                 */
/*   - every active pharmacist is listed; clicking a name SETS or      */
/*     REPLACES the cell's pharmacist, logs it, and closes the dialog  */
/*   - "leave blank" row at the top removes the current assignment     */
/*   - AMBER row = already assigned to THIS session                    */
/*   - RED row   = already working at another site this date (clicking */
/*     warns; Cancel returns to the dialog, OK assigns anyway)         */
/*   - assigning a LOCUM offers to send them a confirmation email      */
/*     (via /circulate); the send is also written to the cell log      */
/*     using an idempotent confirm mutation                            */
/* ------------------------------------------------------------------ */

function CellPopup({ dateStr, pharmacyName, cells, pharmacists, members, mutateCell, saveCellNote, saveCellShifts, createPharmacist, onToast, onClose }) {
  const masked = useMaskNames();
  const member = members.find(m => m.pharmacyName === pharmacyName);
  const entries = member ? cellEntries(cells, member, dateStr) : [];
  const [showNewForm, setShowNewForm] = useState(false);
  const [busyForm, setBusyForm] = useState(false);
  const [busy, setBusy] = useState(false);   // an assignment is being written
  const [log, setLog] = useState(null);      // null = loading

  const byId = useMemo(() => Object.fromEntries(pharmacists.map(p => [p.id, p])), [pharmacists]);
  const entryIds = entries.map(e => e.pid);
  const key = cellKey(dateStr, pharmacyName);

  // per-cell note (v28)
  const savedNote = cells.get(key)?.note || "";
  const [note, setNote] = useState(savedNote);
  const [savingNote, setSavingNote] = useState(false);
  const noteDirty = note !== savedNote;

  /* per-cell shifts (v29) — hours on site. Stored on the cell when it is
     first populated (from the pharmacy's opening hours that day), then
     editable here — e.g. the pharmacist arrived late or left early. */
  const savedShifts = cells.get(key)?.shifts;
  const [shifts, setShifts] = useState(() =>
    Array.isArray(savedShifts) ? savedShifts.map(sh => ({ start: sh.start || "", end: sh.end || "" })) : []);
  const [savingShifts, setSavingShifts] = useState(false);
  // resync if the server writes shifts while the popup is open (first booking)
  const savedShiftsJson = JSON.stringify(savedShifts || []);
  useEffect(() => {
    const s = JSON.parse(savedShiftsJson);
    setShifts(s.map(sh => ({ start: sh.start || "", end: sh.end || "" })));
  }, [savedShiftsJson]);
  const shiftsDirty = JSON.stringify(shifts) !== savedShiftsJson;
  const shiftsValid = shifts.every(sh =>
    shiftMins(sh.start) !== null && shiftMins(sh.end) !== null && shiftMins(sh.end) > shiftMins(sh.start));

  const setShift = (i, field, value) =>
    setShifts(prev => prev.map((sh, x) => (x === i ? { ...sh, [field]: value } : sh)));
  const addShift = () => setShifts(prev => [...prev, { start: "", end: "" }]);
  const removeShift = (i) => setShifts(prev => prev.filter((_, x) => x !== i));

  const doSaveShifts = async () => {
    if (!shiftsDirty || !shiftsValid || savingShifts) return;
    setSavingShifts(true);
    const ok = await saveCellShifts(dateStr, pharmacyName, shifts);
    setSavingShifts(false);
    if (ok) {
      onToast(`Hours on site saved — ${shiftsHours(shifts).toFixed(2)} hrs.`);
      fetchLog();
    }
  };

  const fetchLog = useCallback(async () => {
    const r = await apiGet(`/logs?cellKey=${encodeURIComponent(key)}`);
    setLog(r.ok ? r.data.logs : []);
  }, [key]);

  useEffect(() => { fetchLog(); }, [fetchLog]);

  // conflict check: working (confirmed or provisional) anywhere else same day
  const conflictsFor = (pid) =>
    members
      .filter(m => m.pharmacyName !== pharmacyName)
      .filter(m => cellEntries(cells, m, dateStr).some(e => e.pid === pid))
      .map(m => m.pharmacyName);

  /* Booking confirmation email — sent when the user picks "Confirm and
     send email" in the booking popup (any pharmacist type, not just
     locums). Sent through /circulate (so delivery is also visible in the
     circulation log and Email history), then written to THIS cell's
     change log via an idempotent confirm mutation (the pharmacist is
     already in the assigned set, so no data changes — only the log
     entry is added). */
  const sendBookingEmail = async (p) => {
    if (!p.email) {
      onToast(`${p.name} has no email address in the register — no confirmation email sent.`);
      return;
    }
    const body =
      `Dear ${p.name},\n\n` +
      `This confirms your booking:\n\n` +
      `  •  ${prettyDate(dateStr)} — ${pharmacyName}\n\n` +
      `If you are unable to attend or anything is incorrect, please contact the office as soon as possible.\n\n` +
      `Kind regards`;
    const r = await apiPost("/circulate", {
      subject: `Booking confirmation — ${pharmacyName}, ${prettyDate(dateStr)}`,
      messages: [{ name: p.name, email: p.email, body }]
    });
    if (!r.ok) { onToast(`Confirmation email FAILED: ${r.error}`); return; }
    await mutateCell(dateStr, pharmacyName, "confirm", p.id,
      `Booking confirmation email sent to ${p.name} <${p.email}>`);
    onToast(`Confirmation email sent to ${p.name}.`);
  };

  /* Click a name in the list: open the booking confirmation popup for
     EVERY booking (any pharmacist type). The popup shows date, site and
     pharmacist, and offers Confirm-and-send-email / Confirm-without-email
     / Cancel. Nothing is written until one of the Confirm buttons is
     pressed; Cancel returns to the dialog untouched. */
  const [pendingBooking, setPendingBooking] = useState(null);   // { pid, isProvisionalConfirm, conflicts }

  const choose = (pid) => {
    if (busy) return;
    const p = byId[pid];
    if (!p) return;

    const current = entries.find(e => e.pid === pid);
    if (current && current.status !== "provisional") {
      onToast(`${p.name} is already assigned to this session.`);
      return;
    }
    setPendingBooking({
      pid,
      isProvisionalConfirm: !!current,               // amber row: confirm the provisional entry
      conflicts: current ? [] : conflictsFor(pid)    // working elsewhere this date
    });
  };

  const executeBooking = async (sendEmail) => {
    if (!pendingBooking || busy) return;
    const { pid, isProvisionalConfirm } = pendingBooking;
    const p = byId[pid];
    setBusy(true);
    setPendingBooking(null);
    if (isProvisionalConfirm) {
      await mutateCell(dateStr, pharmacyName, "confirm", pid, `${p.name} confirmed`);
    } else {
      // REPLACE: remove whoever is currently in the cell, then add the choice
      for (const e of entries) {
        const old = byId[e.pid];
        await mutateCell(dateStr, pharmacyName, "remove", e.pid,
          `${old ? old.name : e.pid} → ${p.name}${e.status === "provisional" ? " (replaced unconfirmed entry)" : ""}`);
      }
      await mutateCell(dateStr, pharmacyName, "add", pid,
        `${p.name}${p.type === "Locum" ? " (locum)" : ""} ${entries.length ? "added (change)" : "added"}`);
    }
    if (sendEmail) await sendBookingEmail(p);
    onClose();
  };

  const saveNote = async () => {
    if (!noteDirty || savingNote) return;
    setSavingNote(true);
    const ok = await saveCellNote(dateStr, pharmacyName, note.trim());
    setSavingNote(false);
    if (ok) {
      setNote(note.trim());
      onToast("Note saved.");
      fetchLog();   // the change is appended to the cell log server-side
    }
  };

  /* "Leave blank" row: remove the current assignment(s) and close. */
  const clearCell = async () => {
    if (busy) return;
    if (entries.length === 0) { onClose(); return; }
    setBusy(true);
    for (const e of entries) {
      const old = byId[e.pid];
      await mutateCell(dateStr, pharmacyName, "remove", e.pid,
        `${old ? old.name : e.pid} removed${e.status === "provisional" ? " (was unconfirmed)" : ""} — session left blank`);
    }
    onToast(`Session left blank — ${pharmacyName}, ${prettyDate(dateStr)}.`);
    onClose();
  };

  const saveNewPharmacist = async (form) => {
    setBusyForm(true);
    const created = await createPharmacist(form);
    setBusyForm(false);
    if (!created) return;   // error already toasted
    setShowNewForm(false);
    choose(created.id);     // assign the new pharmacist (replaces current) and close
  };

  // The list: ALL active pharmacists (including any currently assigned).
  // v30: pharmacists who CANNOT take the session (red — already working at
  // another site this date) are always sorted to the END of the list;
  // within each group the order stays alphabetical.
  const list = pharmacists
    .filter(p => p.active !== false)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(p => {
      const isCurrent = entryIds.includes(p.id);
      const isProvisional = entries.some(e => e.pid === p.id && e.status === "provisional");
      const conflicts = isCurrent ? [] : conflictsFor(p.id);
      return { p, isCurrent, isProvisional, conflicts };
    });
  const listSorted = [...list.filter(r => !r.conflicts.length), ...list.filter(r => r.conflicts.length)];

  // v30: the change log lives in its own popup behind a View log button.
  const [showLog, setShowLog] = useState(false);

  const panelStyle = {
    border: "1px solid #e5e7eb", borderRadius: 8, padding: 14,
    background: "#fafafa", display: "flex", flexDirection: "column", minWidth: 0
  };
  const panelTitle = {
    fontWeight: 700, fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5,
    color: "#6b7280", marginBottom: 10, paddingBottom: 6, borderBottom: "1px solid #e5e7eb"
  };
  const sectionHead = { fontWeight: 600, fontSize: 14, margin: "0 0 4px" };

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 1080 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>{displayName(pharmacyName, masked)} — {prettyDate(dateStr)}</h3>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={S.btnGhost} onClick={() => setShowLog(true)}
              title="Every change made to this session — assignments, confirmations, hours and note edits — with date, time and user.">
              View log{log && log.length ? ` (${log.length})` : ""}
            </button>
            <button style={S.btnGhost} onClick={onClose}>Close</button>
          </div>
        </div>

        {/* Two panels: LEFT = this session (who, hours, notes);
            RIGHT = assigning / changing the pharmacist. */}
        <div style={{ display: "flex", gap: 16, alignItems: "stretch", flexWrap: "wrap" }}>

          {/* ---------------- LEFT PANEL — this session ---------------- */}
          <div style={{ ...panelStyle, flex: "1 1 440px" }}>
            <div style={panelTitle}>This session</div>

            {/* Current assignment */}
            <div style={sectionHead}>Currently assigned</div>
            {entries.length === 0 &&
              <div style={{ ...S.small, marginBottom: 8 }}>No pharmacist assigned — session uncovered.</div>}
            {entries.map(({ pid, status }) => {
              const p = byId[pid];
              return (
                <div key={pid} style={{
                  padding: "8px 10px", fontSize: 14, background: "#fff",
                  border: "1px solid #e5e7eb", borderRadius: 6, marginBottom: 8
                }}>
                  <b>{p ? displayName(p.name, masked) : "(deleted pharmacist)"}</b>
                  {p && <span style={{
                    ...S.tag,
                    background: p.type === "Locum" ? "#d1fae5" : "#dbeafe",
                    color: p.type === "Locum" ? "#065f46" : "#1e40af"
                  }}>{p.type}</span>}
                  {status === "provisional" && <span style={{ ...S.tag, background: "#fef3c7", color: "#92400e", border: "1px dashed #d97706" }}
                    title="Populated from the permanent weekly schedule — not yet confirmed. Click their amber row on the right (or double-click the cell) to confirm.">UNCONFIRMED</span>}
                  {p && p.active === false && <span style={{ ...S.tag, background: "#fee2e2", color: "#991b1b" }}>inactive</span>}
                  {p && p.gphc && <span style={{ ...S.small, marginLeft: 8 }}>GPhC {p.gphc}</span>}
                </div>
              );
            })}

            {/* Hours on site (v29) — the shift pairs stored on this cell.
                Captured from the pharmacy's opening hours the moment the
                session was first booked; editable here if the actual time
                on site differed (late arrival, early close, extra shift).
                Used directly by the locum payment calculation. */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "12px 0 4px" }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>Hours on site</span>
              {shifts.length > 0 && shiftsValid &&
                <span style={S.small}>total {shiftsHours(shifts).toFixed(2)} hrs</span>}
              {shifts.length > 0 && !shiftsValid &&
                <span style={{ fontSize: 12, color: "#dc2626" }}>each shift needs a valid HH:MM start and a later end</span>}
            </div>
            {shifts.length === 0 && (
              <div style={{ ...S.small, marginBottom: 6 }}>
                {entries.length === 0
                  ? "No times recorded — they are captured from the pharmacy's opening hours when a pharmacist is first booked in."
                  : "No times recorded for this session — its hours and amount are left EMPTY on payment schedules until shifts are added here."}
              </div>
            )}
            {shifts.map((sh, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, fontSize: 13 }}>
                <span style={{ ...S.small, width: 48 }}>Shift {i + 1}</span>
                <input type="time" style={{ ...S.input, width: 110 }} value={sh.start}
                  onChange={e => setShift(i, "start", e.target.value)} />
                <span>to</span>
                <input type="time" style={{ ...S.input, width: 110 }} value={sh.end}
                  onChange={e => setShift(i, "end", e.target.value)} />
                {shiftMins(sh.start) !== null && shiftMins(sh.end) !== null && shiftMins(sh.end) > shiftMins(sh.start) &&
                  <span style={S.small}>{(((shiftMins(sh.end) - shiftMins(sh.start)) / 60)).toFixed(2)} hrs</span>}
                <button style={S.btnDanger} title="Remove this shift" onClick={() => removeShift(i)}>✕</button>
              </div>
            ))}
            <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
              <button style={S.btnGhost} onClick={addShift}
                title="Add another start/end pair — e.g. a split day (morning and afternoon openings).">+ Add shift</button>
              <button style={{ ...S.btn, opacity: shiftsDirty && shiftsValid && !savingShifts ? 1 : 0.5 }}
                disabled={!shiftsDirty || !shiftsValid || savingShifts}
                title="Saves these times against this session (they replace the captured opening hours) and records the change in the log."
                onClick={doSaveShifts}>
                {savingShifts ? "Saving…" : "Save hours"}
              </button>
            </div>

            {/* Notes (v28) — persisted on this cell; changes are logged */}
            <div style={{ fontWeight: 600, fontSize: 14, margin: "14px 0 4px" }}>Notes</div>
            <textarea
              style={{ ...S.input, width: "100%", minHeight: 70, fontFamily: "inherit", lineHeight: 1.4, resize: "vertical", boxSizing: "border-box" }}
              placeholder="Notes for this session — e.g. cover arrangements, timing, parking. Saved against this cell and visible to all head-office users."
              value={note}
              onChange={e => setNote(e.target.value)} />
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 6 }}>
              <button
                style={{ ...S.btn, opacity: noteDirty && !savingNote ? 1 : 0.5, whiteSpace: "nowrap" }}
                disabled={!noteDirty || savingNote}
                title="Saves the note against this session and records the change in the log."
                onClick={saveNote}>
                {savingNote ? "Saving…" : "Save note"}
              </button>
            </div>
          </div>

          {/* --------------- RIGHT PANEL — assign / change -------------- */}
          <div style={{ ...panelStyle, flex: "1 1 440px" }}>
            <div style={panelTitle}>Assign / change pharmacist</div>

            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
              <span style={S.small}>Click a name — sets or replaces the current pharmacist and closes.</span>
              {busy && <span style={{ color: "#92400e", fontSize: 13 }}>Saving…</span>}
              <button style={{ ...S.btnGhost, marginLeft: "auto" }} onClick={() => setShowNewForm(v => !v)}>+ New pharmacist</button>
            </div>

            {showNewForm && (
              <PharmacistForm busy={busyForm} onSave={saveNewPharmacist} onCancel={() => setShowNewForm(false)} />
            )}

            {/* Scrollable pick list — unavailable (red) pharmacists always last */}
            <div style={{
              border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff",
              flexGrow: 1, minHeight: 220, maxHeight: "52vh", overflowY: "auto",
              opacity: busy ? 0.6 : 1, marginTop: showNewForm ? 8 : 0
            }}>
              <div onClick={clearCell}
                title="Remove the current pharmacist and leave this session blank (uncovered)."
                style={{ padding: "7px 10px", cursor: "pointer", borderBottom: "1px solid #f3f4f6", fontSize: 13, color: "#6b7280", fontStyle: "italic" }}>
                — Leave blank (no pharmacist{entries.length ? " — removes current" : ""}) —
              </div>
              {listSorted.map(({ p, isCurrent, isProvisional, conflicts }) => {
                const bg = isCurrent ? "#fde68a" : conflicts.length ? "#fecaca" : "#fff";
                return (
                  <div key={p.id} onClick={() => choose(p.id)}
                    title={isCurrent
                      ? (isProvisional ? "Assigned to this session (unconfirmed) — click to CONFIRM." : "Already assigned to this session.")
                      : conflicts.length ? `Already working at ${conflicts.join(", ")} on this date — clicking will warn before assigning.`
                      : `Assign ${p.name} to this session.`}
                    style={{
                      padding: "7px 10px", cursor: "pointer", borderBottom: "1px solid #f3f4f6",
                      fontSize: 13, background: bg, display: "flex", alignItems: "center", gap: 8
                    }}>
                    <b>{displayName(p.name, masked)}</b>
                    <span style={{
                      ...S.tag, marginLeft: 0,
                      background: p.type === "Locum" ? "#d1fae5" : "#dbeafe",
                      color: p.type === "Locum" ? "#065f46" : "#1e40af"
                    }}>{p.type}</span>
                    {p.gphc && <span style={S.small}>GPhC {p.gphc}</span>}
                    <span style={{ ...S.small, marginLeft: "auto", textAlign: "right" }}>
                      {isCurrent
                        ? (isProvisional ? "assigned (unconfirmed) — click to confirm" : "assigned to this session")
                        : conflicts.length ? `already at ${conflicts.join(", ")}` : ""}
                    </span>
                  </div>
                );
              })}
              {listSorted.length === 0 &&
                <div style={{ padding: 10, fontSize: 13, color: "#6b7280" }}>
                  No active pharmacists in the register — use + New pharmacist to add one.</div>}
            </div>
          </div>
        </div>

        {/* Change-log popup (v30) — opened from the View log button */}
        {showLog && (
          <div style={{ ...S.overlay, zIndex: 1100, alignItems: "center" }} onClick={() => setShowLog(false)}>
            <div style={{ ...S.modal, width: 720, marginTop: 0, marginBottom: 0 }} onClick={e => e.stopPropagation()}>
              <div style={S.modalHead}>
                <h3 style={S.modalTitle}>Change log — {displayName(pharmacyName, masked)}, {prettyDate(dateStr)}</h3>
                <button style={S.btnGhost} onClick={() => setShowLog(false)}>Close</button>
              </div>
              {log === null && <div style={S.small}>Loading change log…</div>}
              {log !== null && log.length === 0 &&
                <div style={S.small}>No changes recorded for this cell. (Population from the permanent schedule is not logged per cell; confirmations and edits are.)</div>}
              {(log || []).map((l, i) => (
                <div key={i} style={S.logRow}>
                  <span style={{
                    ...S.tag, marginLeft: 0, marginRight: 6,
                    background: (l.action === "add" || l.action === "confirm") ? "#d1fae5" : l.action === "remove" ? "#fee2e2" : "#fef3c7",
                    color: (l.action === "add" || l.action === "confirm") ? "#065f46" : l.action === "remove" ? "#991b1b" : "#92400e"
                  }}>{l.action}</span>
                  {l.detail}
                  <span style={{ ...S.small, marginLeft: 8 }}>
                    {new Date(l.ts).toLocaleString("en-GB")} — {l.user}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Booking confirmation popup — shown for EVERY booking */}
        {pendingBooking && (() => {
          const p = byId[pendingBooking.pid];
          if (!p) return null;
          return (
            <div style={{ ...S.overlay, zIndex: 1100, alignItems: "center" }} onClick={() => setPendingBooking(null)}>
              <div style={{ ...S.modal, width: 460, marginTop: 0, marginBottom: 0 }} onClick={e => e.stopPropagation()}>
                <h3 style={{ ...S.modalTitle, marginBottom: 12 }}>Confirm booking</h3>
                <div style={{ fontSize: 14, lineHeight: 1.8, marginBottom: 10 }}>
                  <b>Date:</b> {prettyDate(dateStr)}<br />
                  <b>Site:</b> {displayName(pharmacyName, masked)}<br />
                  <b>Pharmacist:</b> {displayName(p.name, masked)}
                  <span style={{
                    ...S.tag,
                    background: p.type === "Locum" ? "#d1fae5" : "#dbeafe",
                    color: p.type === "Locum" ? "#065f46" : "#1e40af"
                  }}>{p.type}</span>
                </div>
                {pendingBooking.conflicts.length > 0 && (
                  <div style={{
                    background: "#fee2e2", border: "1px solid #fca5a5", borderRadius: 6,
                    padding: "8px 10px", fontSize: 13, color: "#991b1b", marginBottom: 12
                  }}>
                    ⚠ {p.name} is already working at {pendingBooking.conflicts.join(", ")} on this date.
                    Confirming will double-book them.
                  </div>
                )}
                {!p.email && (
                  <div style={{ ...S.small, marginBottom: 10 }}>
                    {p.name} has no email address in the register, so no confirmation email can be sent.
                  </div>
                )}
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                  <button style={S.btnGhost} onClick={() => setPendingBooking(null)}>Cancel</button>
                  <button style={S.btn} onClick={() => executeBooking(false)}>Confirm without email</button>
                  <button style={{ ...S.btnGreen, opacity: p.email ? 1 : 0.5 }} disabled={!p.email}
                    title={p.email ? `Books the session and emails a confirmation to ${p.email}.` : "No email address in the register."}
                    onClick={() => executeBooking(true)}>Confirm and send email</button>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Pharmacist list popup — register + Active + weekly pattern          */
/* ------------------------------------------------------------------ */

function PharmacistListPopup({ pharmacists, members, createPharmacist, updatePharmacist, deletePharmacist, onClose }) {
  const masked = useMaskNames();
  const [editingId, setEditingId] = useState(null);
  const [patternId, setPatternId] = useState(null);
  const [adding, setAdding] = useState(false);
  const [busyForm, setBusyForm] = useState(false);
  const list = pharmacists.slice().sort((a, b) => a.name.localeCompare(b.name));

  const patternSummary = (p) =>
    WEEK_ORDER.filter(d => p.weeklyPattern?.[d]).map(d => `${d.slice(0, 3)}: ${p.weeklyPattern[d]}`).join(" · ");

  const saveNew = async (f) => {
    setBusyForm(true);
    const created = await createPharmacist(f);
    setBusyForm(false);
    if (created) setAdding(false);
  };

  const saveEdit = async (id, f) => {
    setBusyForm(true);
    const ok = await updatePharmacist(id, f);
    setBusyForm(false);
    if (ok) setEditingId(null);
  };

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 1040 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Pharmacist list</h3>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={S.btnGreen} onClick={() => { setAdding(true); setEditingId(null); setPatternId(null); }}>+ Add pharmacist</button>
            <button style={S.btnGhost} onClick={onClose}>Close</button>
          </div>
        </div>

        {adding && <PharmacistForm busy={busyForm} onCancel={() => setAdding(false)} onSave={saveNew} />}

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, marginTop: 10 }}>
          <thead><tr>
            {["Active", "Name", "GPhC", "Mobile", "Email", "Address", "Type", "Permanent days", ""].map(h =>
              <th key={h} style={{ textAlign: "left", borderBottom: "1px solid #d1d5db", padding: 6, background: "#f9fafb" }}>{h}</th>)}
          </tr></thead>
          <tbody>
            {list.map(p => (
              <React.Fragment key={p.id}>
                <tr style={{ opacity: p.active === false ? 0.55 : 1 }}>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>
                    <input type="checkbox" checked={p.active !== false}
                      title="Active — untick to hide from pick lists, weekly patterns and circulations"
                      onChange={e => updatePharmacist(p.id, { active: e.target.checked })} />
                  </td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}><b>{displayName(p.name, masked)}</b></td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>{p.gphc}</td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>{p.mobile}</td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>{p.email}</td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>{p.address}</td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6" }}>
                    <span style={{
                      ...S.tag, marginLeft: 0,
                      background: p.type === "Locum" ? "#d1fae5" : "#dbeafe",
                      color: p.type === "Locum" ? "#065f46" : "#1e40af"
                    }}>{p.type}</span>
                    {p.type === "Locum" && Number(p.hourlyRate) > 0 &&
                      <span style={{ ...S.small, marginLeft: 6 }} title="Hourly pay rate — used on the monthly payment schedule">
                        £{Number(p.hourlyRate).toFixed(2)}/hr</span>}
                  </td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6", fontSize: 12, maxWidth: 220 }}>
                    {patternSummary(p) || <span style={S.small}>—</span>}
                  </td>
                  <td style={{ padding: 6, borderBottom: "1px solid #f3f4f6", whiteSpace: "nowrap" }}>
                    <button style={{ ...S.btnGhost, marginRight: 6, padding: "3px 8px" }}
                      title="Set this pharmacist's permanent weekly days (Mon-Sun pharmacy per day). Changes apply from today onwards: unconfirmed placements are moved/added/removed to match; confirmed entries are never touched."
                      onClick={() => { setPatternId(patternId === p.id ? null : p.id); setEditingId(null); setAdding(false); }}>Days</button>
                    <button style={{ ...S.btnGhost, marginRight: 6, padding: "3px 8px" }}
                      title="Edit this pharmacist's registry details (name, GPhC, contact, type, active)."
                      onClick={() => { setEditingId(editingId === p.id ? null : p.id); setPatternId(null); setAdding(false); }}>Edit</button>
                    <button style={S.btnDanger} onClick={() => {
                      if (window.confirm(`Remove ${p.name} from the register? Existing rota entries will show "(deleted pharmacist)". Consider unticking Active instead.`))
                        deletePharmacist(p.id);
                    }}>Delete</button>
                  </td>
                </tr>
                {patternId === p.id && (
                  <tr><td colSpan={9} style={{ padding: "6px 0" }}>
                    <WeeklyPatternEditor pharmacist={p} members={members} updatePharmacist={updatePharmacist} />
                  </td></tr>
                )}
                {editingId === p.id && (
                  <tr><td colSpan={9}>
                    <PharmacistForm initial={p} busy={busyForm} onCancel={() => setEditingId(null)}
                      onSave={(f) => saveEdit(p.id, f)} />
                  </td></tr>
                )}
              </React.Fragment>
            ))}
            {list.length === 0 && <tr><td colSpan={9} style={{ padding: 12, color: "#6b7280" }}>
              No pharmacists yet — add your regular pharmacists and locums here, or on the fly from any rota cell.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Circulation history — shared by the toolbar popup and the           */
/* circulate popup. Fetches from the server on mount.                  */
/* ------------------------------------------------------------------ */

function CirculationHistory({ onToast }) {
  const masked = useMaskNames();
  const [history, setHistory] = useState(null);      // null = loading
  const [sel, setSel] = useState(null);
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    (async () => {
      const r = await apiGet("/circulations?limit=50");
      setHistory(r.ok ? r.data.circulations : []);
      if (!r.ok) onToast(r.error);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const c = (history || []).find(x => x._id === sel);
  const msgs = c ? (c.messages || (c.results || []).map(r => ({ ...r, body: "(body not stored for this circulation)" }))) : [];
  const msg = msgs[msgIdx] || msgs[0];

  return (
    <div style={{ display: "flex", gap: 14 }}>
      <div style={{ flex: "0 0 230px" }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Circulation dates</div>
        {history === null && <div style={S.small}>Loading…</div>}
        {history !== null && history.length === 0 && <div style={S.small}>No previous circulations.</div>}
        {(history || []).map(h => (
          <div key={h._id}
            onClick={() => { setSel(h._id); setMsgIdx(0); }}
            style={{
              padding: "6px 8px", borderRadius: 4, cursor: "pointer", fontSize: 13,
              background: sel === h._id ? "#dbeafe" : "transparent"
            }}>
            {new Date(h.sentAt).toLocaleString("en-GB")}
            <span style={{ ...S.small, marginLeft: 6 }}>({h.sent} sent)</span>
            {h.failed > 0 && <span style={{ ...S.tag, background: "#fee2e2", color: "#991b1b" }}>{h.failed} failed</span>}
          </div>
        ))}
      </div>
      <div style={{ flexGrow: 1, minWidth: 0 }}>
        {!c && <div style={S.small}>Select a date to view the email and recipient list.</div>}
        {c && (
          <div>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{c.subject}</div>
            <div style={{ ...S.small, margin: "4px 0 8px" }}>
              Sent by {c.sentBy} — To: {(c.results || msgs).map(r => `${displayName(r.name, masked)} <${masked ? "…" : r.email}>`).join("; ")}
            </div>
            {msgs.length > 1 && (
              <select style={{ ...S.select, marginBottom: 8 }} value={msgIdx}
                onChange={e => setMsgIdx(Number(e.target.value))}>
                {msgs.map((r, i) => <option key={i} value={i}>View email sent to {displayName(r.name, masked)}</option>)}
              </select>
            )}
            {msg && <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: 13, background: "#f9fafb", padding: 10, borderRadius: 6 }}>{msg.body}</pre>}
          </div>
        )}
      </div>
    </div>
  );
}

// Standalone popup for the main-page "Circulation log" button.
function CirculationLogPopup({ onToast, onClose }) {
  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 900 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Locum circulation log</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>
        <div style={{ ...S.small, marginBottom: 10 }}>
          Every "Circulate unfilled slots" send, with per-recipient delivery status and
          the exact personalised email each locum received.
        </div>
        <CirculationHistory onToast={onToast} />
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Circulation popup (personalised emails + history + summaries)       */
/* ------------------------------------------------------------------ */

function CirculatePopup({ pharmacists, members, cells, uncoveredSessions, days, onToast, onClose }) {
  const masked = useMaskNames();
  // Circulation recipients: ALL pharmacist types (full-time, part-time,
  // locum) — restricted only to active pharmacists with an email address.
  const recipientPool = pharmacists.filter(p => p.active !== false && p.email);

  // Window: the next {days} days FROM AND INCLUDING TOMORROW.
  const start = addDays(ymd(new Date()), 1);
  const end = addDays(start, days - 1);

  // sessions each locum is FREE to work (not working anywhere that date)
  const freeSessionsFor = useMemo(() => {
    const map = {};
    recipientPool.forEach(l => {
      const busy = busyDates(cells, l.id, start, end);
      map[l.id] = uncoveredSessions.filter(s => !busy.has(s.date));
    });
    return map;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cells, uncoveredSessions, start, end]);

  const [subject, setSubject] = useState(`Locum cover required — next ${days} day${days > 1 ? "s" : ""}`);
  const [template, setTemplate] = useState(
    `Dear colleague,\n\nWe need the following sessions covered:\n\n${SESSIONS_TOKEN}\n\nIf you are available for any of the above, please reply to this email or contact the office.\n\nKind regards`
  );
  // default ON, except recipients with no free sessions
  const [included, setIncluded] = useState(() =>
    Object.fromEntries(recipientPool.map(l => [l.id, (freeSessionsFor[l.id] || []).length > 0])));
  const [extras, setExtras] = useState([]);          // ad-hoc {name,email} — get the FULL session list
  const [previewId, setPreviewId] = useState("");
  const [sending, setSending] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const sessionLines = (sessions) =>
    sessions.length
      ? sessions.map(s => `  •  ${prettyDate(s.date)} — ${s.pharmacy}`).join("\n")
      : "  (no sessions currently unfilled)";

  const renderBody = (sessions) => template.split(SESSIONS_TOKEN).join(sessionLines(sessions));

  const buildMessages = () => {
    const msgs = recipientPool
      .filter(l => included[l.id])
      .map(l => ({ name: l.name, email: l.email, body: renderBody(freeSessionsFor[l.id] || []) }));
    extras.forEach(x => msgs.push({ name: x.name, email: x.email, body: renderBody(uncoveredSessions) }));
    return msgs;
  };

  const addRecipient = () => {
    const name = window.prompt("Recipient name:");
    if (!name) return;
    const email = window.prompt("Recipient email address:");
    if (!email) return;
    setExtras(x => [...x, { name: name.trim(), email: email.trim() }]);
  };

  const send = async () => {
    const messages = buildMessages();
    if (messages.length === 0) { onToast("No recipients selected."); return; }
    setSending(true);
    const r = await apiPost("/circulate", { subject, messages });
    setSending(false);
    if (!r.ok) { onToast(`Circulation failed: ${r.error}`); return; }
    const { sent, failed } = r.data;
    onToast(failed
      ? `Circulation: ${sent} sent, ${failed} FAILED — see previous circulations for detail.`
      : `Circulation sent — ${sent} personalised email(s).`);
    onClose();
  };

  const previewRecipient = recipientPool.find(l => l.id === previewId);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 1020 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Circulate unfilled slots — next {days} day{days > 1 ? "s" : ""} ({prettyDate(start)} to {prettyDate(end)})</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>

        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
          {/* Left: editable email template + per-recipient preview */}
          <div style={{ flex: "1 1 60%" }}>
            <div style={{ ...S.small, marginBottom: 4 }}>Subject</div>
            <input style={{ ...S.input, width: "100%", boxSizing: "border-box" }}
              value={subject} onChange={e => setSubject(e.target.value)} />
            <div style={{ ...S.small, margin: "10px 0 4px" }}>
              Email template (editable) — each recipient only receives the sessions they are free to work,
              inserted where <b>{SESSIONS_TOKEN}</b> appears.
            </div>
            <textarea style={{ ...S.input, width: "100%", boxSizing: "border-box", minHeight: 220, fontFamily: "inherit", lineHeight: 1.4 }}
              value={template} onChange={e => setTemplate(e.target.value)} />
            {!template.includes(SESSIONS_TOKEN) &&
              <div style={{ ...S.small, color: "#dc2626", marginTop: 4 }}>
                Warning: the template no longer contains {SESSIONS_TOKEN}, so no session list will be inserted.</div>}
            {uncoveredSessions.length === 0 &&
              <div style={{ ...S.small, color: "#059669", marginTop: 6 }}>No unfilled slots in the selected period 🎉</div>}

            <div style={{ ...S.small, margin: "12px 0 4px" }}>Preview a recipient's personalised email</div>
            <select style={S.select} value={previewId} onChange={e => setPreviewId(e.target.value)}>
              <option value="">— select recipient —</option>
              {recipientPool.map(l => <option key={l.id} value={l.id}>{displayName(l.name, masked)} ({(freeSessionsFor[l.id] || []).length} free session{(freeSessionsFor[l.id] || []).length === 1 ? "" : "s"})</option>)}
            </select>
            {previewRecipient && (
              <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: 12.5, background: "#f9fafb", padding: 10, borderRadius: 6, marginTop: 8, border: "1px solid #e5e7eb" }}>
                {renderBody(freeSessionsFor[previewRecipient.id] || [])}
              </pre>
            )}
          </div>

          {/* Right: recipients */}
          <div style={{ flex: "1 1 40%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 6, padding: 10 }}>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>Recipients — all active pharmacists</div>
            <div style={{ ...S.small, marginBottom: 6 }}>Full-time, part-time and locum. Anyone with no free sessions in the period is unticked by default.</div>
            {recipientPool.length === 0 && <div style={S.small}>No active pharmacists with email addresses in the register.</div>}
            {recipientPool.map(l => {
              const free = (freeSessionsFor[l.id] || []).length;
              return (
                <label key={l.id} style={{ display: "flex", gap: 8, alignItems: "center", padding: "4px 0", fontSize: 13, cursor: "pointer" }}>
                  <input type="checkbox" checked={!!included[l.id]}
                    onChange={e => setIncluded({ ...included, [l.id]: e.target.checked })} />
                  <span>
                    <b>{displayName(l.name, masked)}</b>
                    <span style={{
                      ...S.tag,
                      background: l.type === "Locum" ? "#d1fae5" : "#dbeafe",
                      color: l.type === "Locum" ? "#065f46" : "#1e40af"
                    }}>{l.type}</span>
                    <span style={{ ...S.small, marginLeft: 6 }}>{l.email}</span>
                    <span style={{
                      ...S.tag,
                      background: free ? "#d1fae5" : "#fee2e2",
                      color: free ? "#065f46" : "#991b1b"
                    }}>{free} free</span>
                  </span>
                </label>
              );
            })}
            {extras.map((x, i) => (
              <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", padding: "4px 0", fontSize: 13 }}>
                <span>✉️ <b>{x.name}</b> <span style={S.small}>{x.email}</span> <span style={{ ...S.tag, background: "#e5e7eb", color: "#374151" }}>full list</span></span>
                <button style={{ ...S.btnDanger, marginLeft: "auto" }}
                  onClick={() => setExtras(extras.filter((_, j) => j !== i))}>×</button>
              </div>
            ))}
            <button style={{ ...S.btnGhost, marginTop: 8, width: "100%" }} onClick={addRecipient}>+ Add another recipient</button>
          </div>
        </div>

        {/* Footer buttons row */}
        <div style={{ display: "flex", gap: 10, marginTop: 16, alignItems: "center", flexWrap: "wrap" }}>
          <button style={{ ...S.btnGreen, opacity: sending ? 0.6 : 1 }} disabled={sending} onClick={send}
            title="Sends one personalised email per ticked recipient (register pharmacists get only their free sessions; ad-hoc recipients get the full list) and records everything in the circulation log.">
            {sending ? "Sending…" : `Send circulation (${buildMessages().length})`}</button>
          <div style={{ flexGrow: 1 }} />
          <button style={S.btnGhost} onClick={() => setShowHistory(v => !v)}
            title="Every previous circulation: date, recipients, delivery status, and the exact personalised email each locum received.">
            View previous circulations {showHistory ? "▲" : "▼"}</button>
        </div>

        {/* Previous circulations (shared history component) */}
        {showHistory && (
          <div style={{ marginTop: 12, borderTop: "1px solid #e5e7eb", paddingTop: 12 }}>
            <CirculationHistory onToast={onToast} />
          </div>
        )}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Monthly payment summaries popup — TWO RUNS (v31):                   */
/*   1. LOCUMS: every session worked by Locum-type pharmacists.        */
/*   2. ADDITIONAL SESSIONS: NON-locum pharmacists (full/part-time),   */
/*      ONLY cells OUTSIDE their permanent weekly schedule (their      */
/*      pattern cells for that day+site are excluded) — extra shifts.  */
/* Hours per session come ONLY from the shifts stored on the cell; a   */
/* session with no stored shifts keeps its hours/amount EMPTY (v31 —   */
/* no fallback). Word documents are DOWNLOADED locally (never emailed) */
/* so the manager can review rates/hours/amounts before payment.       */
/* Tabbed spreadsheets are produced ONE PER BRANCH for each run.       */
/* ------------------------------------------------------------------ */

// Regroup one run's sessions into per-branch tabbed workbooks: for each
// branch a Summary sheet then one tab per pharmacist with that branch's
// sessions. Sessions with hours === null keep times/hours/amount EMPTY;
// totals sum recorded sessions only. Shared by both runs.
function buildBranchWorkbooks({ sessionsByPid, personById, monthLabel, fromStr, toStr,
  orgName, summaryMonth, runTitle, filenamePrefix, personColumn, extraSummaryLine, withNarrative }) {
  const money = (n) => Math.round(n * 100) / 100;
  const byBranch = {};
  Object.entries(sessionsByPid).forEach(([pid, sessions]) => {
    sessions.forEach(s => {
      ((byBranch[s.pharmacy] = byBranch[s.pharmacy] || {})[pid] =
        byBranch[s.pharmacy][pid] || []).push(s);
    });
  });
  return Object.entries(byBranch)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([branch, perPerson]) => {
      const summaryRows = [
        [runTitle],
        ["Branch", branch],
        ["Organisation", orgName],
        ["Period", `${monthLabel} (${fromStr} to ${toStr})`],
        ["Generated", new Date().toLocaleString("en-GB")],
        ...(extraSummaryLine ? [[extraSummaryLine]] : []),
        [],
        [personColumn, "GPhC", "Sessions", "Recorded hours", "Rate (£/hr)", "Total (£)"]
          .concat(withNarrative ? [""] : [])
      ];
      const personSheets = [];
      let branchTotal = 0;
      Object.entries(perPerson).forEach(([pid, sessions]) => {
        const p = personById[pid];
        if (!p) return;
        const rate = Number(p.hourlyRate);
        const hasRate = Number.isFinite(rate) && rate > 0;
        const recorded = sessions.filter(s => s.hours !== null && s.hours !== undefined);
        const unrecorded = sessions.length - recorded.length;
        const hours = recorded.reduce((a, s) => a + (Number(s.hours) || 0), 0);
        const total = hasRate ? money(hours * rate) : null;
        if (total !== null) branchTotal += total;
        summaryRows.push([p.name, p.gphc || "", sessions.length, money(hours),
          hasRate ? rate : "not set", total !== null ? total : ""]);
        const rows = [
          [`${runTitle} — ${p.name}`],
          ["Branch", branch],
          ["Period", monthLabel],
          ["GPhC", p.gphc || ""], ["Email", p.email || ""],
          ["Hourly rate (£/hr)", hasRate ? rate : "not set"],
          [],
          ["Date", "Status", "Times on site", "Hours on site", "Rate (£/hr)", "Amount (£)"]
            .concat(withNarrative ? ["Narrative"] : [])
        ];
        sessions.forEach(s => {
          const hasHours = s.hours !== null && s.hours !== undefined;
          rows.push([
            prettyDate(s.date), s.status === "provisional" ? "UNCONFIRMED" : "confirmed",
            s.times || "",
            hasHours ? Number(s.hours) : "",
            hasHours && hasRate ? rate : "",
            hasHours && hasRate ? money(Number(s.hours) * rate) : ""
          ].concat(withNarrative ? [s.narrative || ""] : []));
        });
        rows.push(["Total (recorded sessions)", "", "", money(hours), "", total !== null ? total : ""]);
        if (unrecorded) rows.push([`${unrecorded} session${unrecorded === 1 ? "" : "s"} above have no recorded hours — values left blank for manual completion`]);
        personSheets.push({ name: p.name, rows });
      });
      summaryRows.push([]);
      summaryRows.push(["Branch total (£)", "", "", "", "", money(branchTotal)]);
      return {
        branch,
        filename: `${filenamePrefix}_${branch.replace(/[^\w-]+/g, "_")}_${summaryMonth}.xlsx`,
        sheets: [{ name: "Summary", rows: summaryRows }, ...personSheets]
      };
    });
}

function MonthlySummariesPopup({ pharmacists, members, cells, ensureRange, settings, saveSettings, onClose }) {
  const [summaryMonth, setSummaryMonth] = useState(() => {
    const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  const [makeXlsx, setMakeXlsx] = useState(true);   // also produce the tabbed workbooks — default ON

  // Summaries need that month's cells loaded.
  useEffect(() => {
    const [y, m] = summaryMonth.split("-").map(Number);
    const from = `${summaryMonth}-01`;
    const to = ymd(new Date(y, m, 0));
    ensureRange(from, to);
  }, [summaryMonth, ensureRange]);

  /* ---- both runs' sessions, built in one pass over the month ----
     LOCUM run: every session by a Locum-type pharmacist.
     ADDITIONAL run: NON-locum pharmacists, EXCLUDING cells that are part
     of their permanent weekly schedule (weeklyPattern day === pharmacy) —
     so only their EXTRA sessions are picked up.
     hours: the cell's stored shifts summed, or NULL when none recorded
     (v31 — that session's hours/amount stay empty everywhere). */
  /* ---- contracted-hours lookups for swap days (v33) ----
     Scan the month for non-locum entries at a site DIFFERENT from their
     weeklyPattern site: each needs the SCHEDULED site's opening hours for
     that date from pharmace_common_db.pharmacies (the source of truth for
     what they were supposed to work). Fetched in batch via
     POST /rota/opening-hours and cached per (date|site) for the session;
     the additional-run downloads are disabled until lookups finish. */
  const swapLookups = useMemo(() => {
    const [y, m] = summaryMonth.split("-").map(Number);
    const lastDay = new Date(y, m, 0).getDate();
    const need = new Map();
    for (let day = 1; day <= lastDay; day++) {
      const dateStr = `${summaryMonth}-${String(day).padStart(2, "0")}`;
      members.forEach(mem => {
        cellEntries(cells, mem, dateStr).forEach(({ pid }) => {
          const p = pharmacists.find(x => x.id === pid);
          if (!p || p.type === "Locum") return;
          const patternSite = (p.weeklyPattern || {})[dowOf(dateStr)] || "";
          if (!patternSite || patternSite === mem.pharmacyName) return;
          const key = `${dateStr}|${patternSite}`;
          if (!need.has(key)) {
            const pm = members.find(x => x.pharmacyName === patternSite);
            need.set(key, { date: dateStr, pharmacyName: patternSite, pharmacyId: pm?.pharmacyId ?? pm?._id ?? null });
          }
        });
      });
    }
    return [...need.values()];
  }, [cells, pharmacists, members, summaryMonth]);

  const contractedCacheRef = useRef(new Map());   // 'date|site' -> { found, hours }
  const [contractedMap, setContractedMap] = useState(new Map());
  const [contractedLoading, setContractedLoading] = useState(false);

  useEffect(() => {
    const missing = swapLookups.filter(q => !contractedCacheRef.current.has(`${q.date}|${q.pharmacyName}`));
    if (!missing.length) {
      setContractedMap(new Map(contractedCacheRef.current));
      setContractedLoading(false);
      return;
    }
    let cancelled = false;
    setContractedLoading(true);
    (async () => {
      for (let i = 0; i < missing.length; i += 200) {
        const batch = missing.slice(i, i + 200);
        const r = await apiPost("/opening-hours", { queries: batch });
        if (r.ok) {
          (r.data.results || []).forEach(res =>
            contractedCacheRef.current.set(`${res.date}|${res.pharmacyName}`,
              res.found ? { found: true, hours: Number(res.hours) || 0 } : { found: false, hours: null }));
        }
        // failed batches stay uncached (unknown this view) and retry on next change
        if (cancelled) return;
      }
      if (!cancelled) {
        setContractedMap(new Map(contractedCacheRef.current));
        setContractedLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [swapLookups]);

  const { locumSessions, additionalSessions, swapAnnotations } = useMemo(() => {
    const [y, m] = summaryMonth.split("-").map(Number);
    const lastDay = new Date(y, m, 0).getDate();
    const locum = {}, additional = {};
    const annotations = [];   // idempotent cell-log narratives for swaps (v32)
    const monthLbl = `${MONTH_NAMES[m - 1]} ${y}`;
    for (let day = 1; day <= lastDay; day++) {
      const dateStr = `${summaryMonth}-${String(day).padStart(2, "0")}`;
      members.forEach(mem => {
        cellEntries(cells, mem, dateStr).forEach(({ pid, status }) => {
          const p = pharmacists.find(x => x.id === pid);
          if (!p) return;
          const session = {
            date: dateStr, pharmacy: mem.pharmacyName, status,
            hours: sessionHours(cells, mem, dateStr),   // stored shifts or null
            times: sessionTimes(cells, mem, dateStr)    // "" when none recorded
          };
          if (p.type === "Locum") {
            (locum[pid] = locum[pid] || []).push(session);
            return;
          }
          const patternSite = (p.weeklyPattern || {})[dowOf(dateStr)] || "";
          if (patternSite === mem.pharmacyName) return;   // normal scheduled cell — excluded

          if (!patternSite) {
            // plain EXTRA session — not scheduled to work anywhere this day
            session.narrative = "Additional session — not scheduled to work this day";
            (additional[pid] = additional[pid] || []).push(session);
            return;
          }

          /* SWAP (v33): scheduled at patternSite, worked here instead.
             WORKED hours = this cell's stored shifts (manager-editable).
             CONTRACTED hours = the SCHEDULED site's opening hours that day,
             from pharmace_common_db.pharmacies (fetched batch, above).
             Equal → excluded, log only. Unequal → the signed DIFFERENCE
             is paid, with a narrative on the row AND in the cell's log.
             Unknown on either side → blank figures, manual review. */
          const worked = session.hours;
          const c = contractedMap.get(`${dateStr}|${patternSite}`);
          const contracted = c && c.found ? { hours: c.hours } : null;
          if (worked !== null && contracted) {
            const diff = Math.round((worked - contracted.hours) * 100) / 100;
            if (Math.abs(diff) < 0.005) {
              annotations.push({
                date: dateStr, pharmacyName: mem.pharmacyName,
                detail: `Swap ignored for pay (${monthLbl} schedule): ${p.name} was scheduled at ${patternSite} for ${contracted.hours.toFixed(2)} hrs (that site's opening hours) and worked ${worked.toFixed(2)} hrs here — equal hours, so this day swap is NOT treated as an additional/locum session.`
              });
              return;   // excluded from the schedule
            }
            session.hours = diff;
            session.narrative = `Swap from ${patternSite}: contracted ${contracted.hours.toFixed(2)} hrs (that site's opening hours), worked ${worked.toFixed(2)} hrs — ${diff > 0 ? "+" : ""}${diff.toFixed(2)} hrs ${diff > 0 ? "extra paid" : "deducted"}`;
            annotations.push({
              date: dateStr, pharmacyName: mem.pharmacyName,
              detail: `Swap pay adjustment (${monthLbl} schedule): ${p.name} was scheduled at ${patternSite} for ${contracted.hours.toFixed(2)} hrs (that site's opening hours) but worked ${worked.toFixed(2)} hrs here — ${diff > 0 ? "+" : ""}${diff.toFixed(2)} hrs ${diff > 0 ? "added to" : "deducted (negative) on"} the additional-sessions payment schedule.`
            });
          } else {
            const missing = [
              worked === null ? "worked hours not recorded on this session" : null,
              !contracted ? `${patternSite} could not be matched in the pharmacy records (opening hours unknown)` : null
            ].filter(Boolean).join(" and ");
            session.hours = null;
            session.narrative = `Swap from ${patternSite} — ${missing}; figures left blank, manual review required`;
            annotations.push({
              date: dateStr, pharmacyName: mem.pharmacyName,
              detail: `Swap needs manual review (${monthLbl} schedule): ${p.name} was scheduled at ${patternSite} but worked here — ${missing}, so the payment figures are left blank.`
            });
          }
          (additional[pid] = additional[pid] || []).push(session);
        });
      });
    }
    return { locumSessions: locum, additionalSessions: additional, swapAnnotations: annotations };
  }, [cells, pharmacists, members, summaryMonth, contractedMap]);

  /* v32: write the swap narratives to each cell's change log the moment
     an additional-sessions run is downloaded. Server-side the write is
     IDEMPOTENT (identical cellKey+detail rows are skipped), so repeated
     downloads never duplicate entries; a changed calculation produces a
     new, dated entry — which is itself an audit trail. Fire-and-forget. */
  const annotateSwapLogs = useCallback(() => {
    if (!swapAnnotations.length) return;
    apiPost("/logs/annotate", { entries: swapAnnotations });
  }, [swapAnnotations]);

  const monthLabel = (() => {
    const [y, m] = summaryMonth.split("-").map(Number);
    return `${MONTH_NAMES[m - 1]} ${y}`;
  })();
  const [y0, m0] = summaryMonth.split("-").map(Number);
  const fromStr = `${summaryMonth}-01`;
  const toStr = `${summaryMonth}-${String(new Date(y0, m0, 0).getDate()).padStart(2, "0")}`;
  const orgName = localStorage.getItem("organisationName") || "";

  const downloadSummary = (pid, kind) => {
    const p = pharmacists.find(x => x.id === pid);
    if (!p) return;
    if (kind === "additional") annotateSwapLogs();
    const sessions = kind === "additional" ? additionalSessions[pid] : locumSessions[pid];
    const prefix = kind === "additional" ? "Additional_sessions_schedule" : "Payment_schedule";
    downloadDoc(
      `${prefix}_${p.name.replace(/\s+/g, "_")}_${summaryMonth}.doc`,
      buildPaymentScheduleDoc(p, sessions, monthLabel, kind)
    );
  };

  /* Per-branch tabbed workbooks for each run (v29/v31). */
  const locumWorkbooks = useMemo(() => buildBranchWorkbooks({
    sessionsByPid: locumSessions, personById: Object.fromEntries(pharmacists.map(p => [p.id, p])),
    monthLabel, fromStr, toStr, orgName, summaryMonth,
    runTitle: "Locum payment schedules", filenamePrefix: "Locum_payment_schedules",
    personColumn: "Locum"
  }), [locumSessions, pharmacists, monthLabel, fromStr, toStr, orgName, summaryMonth]);

  const additionalWorkbooks = useMemo(() => buildBranchWorkbooks({
    sessionsByPid: additionalSessions, personById: Object.fromEntries(pharmacists.map(p => [p.id, p])),
    monthLabel, fromStr, toStr, orgName, summaryMonth,
    runTitle: "Additional sessions payment schedules", filenamePrefix: "Additional_sessions_payment_schedules",
    personColumn: "Pharmacist", withNarrative: true,
    extraSummaryLine: "Full/part-time pharmacists — out-of-schedule work only; day swaps netted (see Narrative column)"
  }), [additionalSessions, pharmacists, monthLabel, fromStr, toStr, orgName, summaryMonth]);

  const downloadRun = (kind) => {
    if (kind === "additional") annotateSwapLogs();
    const sess = kind === "additional" ? additionalSessions : locumSessions;
    const books = kind === "additional" ? additionalWorkbooks : locumWorkbooks;
    const pids = Object.keys(sess);
    pids.forEach((pid, i) => setTimeout(() => downloadSummary(pid, kind), i * 400));
    if (makeXlsx) books.forEach((wb, i) =>
      setTimeout(() => downloadXlsx(wb.filename, wb.sheets), (pids.length + i) * 400));
  };

  const runRow = (pid, sessions, kind) => {
    const p = pharmacists.find(x => x.id === pid);
    const rate = Number(p?.hourlyRate);
    const recorded = sessions.filter(s => s.hours !== null && s.hours !== undefined);
    const unrecorded = sessions.length - recorded.length;
    const hours = recorded.reduce((a, s) => a + (Number(s.hours) || 0), 0);
    return (
      <div key={pid} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13 }}>
        <b>{p ? p.name : pid}</b>
        {kind === "additional" && p && <span style={{ ...S.tag, background: "#dbeafe", color: "#1e40af" }}>{p.type}</span>}
        <span style={S.small}>{p?.email}</span>
        <span style={S.small}>
          {sessions.length} session{sessions.length > 1 ? "s" : ""} · {hours.toFixed(2)} recorded hrs
          {unrecorded ? ` · ${unrecorded} without hours` : ""}
        </span>
        {Number.isFinite(rate) && rate > 0
          ? <span style={S.small}>£{rate.toFixed(2)}/hr · total £{(hours * rate).toFixed(2)}</span>
          : <span style={{ ...S.tag, background: "#fef3c7", color: "#92400e" }}
              title="Add an hourly rate in the pharmacist register to auto-calculate amounts.">no rate set</span>}
        <button style={{ ...S.btn, marginLeft: "auto", opacity: kind === "additional" && contractedLoading ? 0.5 : 1 }}
          disabled={kind === "additional" && contractedLoading}
          onClick={() => downloadSummary(pid, kind)}>Download Word doc</button>
      </div>
    );
  };

  const sectionHead = (title, sub) => (
    <div style={{ margin: "16px 0 4px" }}>
      <span style={{ fontWeight: 700, fontSize: 14 }}>{title}</span>
      <span style={{ ...S.small, marginLeft: 8 }}>{sub}</span>
    </div>
  );

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 780 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Payment summaries</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>
        <div style={{ ...S.small, marginBottom: 10 }}>
          Two runs for any month, both using the shift times and hours recorded on each session
          (a session with no recorded times keeps its hours and amount EMPTY) and the hourly rate
          from the pharmacist register. Word documents plus one tabbed spreadsheet per branch,
          downloaded for review — nothing is emailed from here.
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 8, flexWrap: "wrap" }}>
          <div style={{ fontWeight: 600, fontSize: 13 }}>Payment schedules for</div>
          <input type="month" style={S.input} value={summaryMonth} onChange={e => setSummaryMonth(e.target.value)} />
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}
            title="Also downloads ONE .xlsx workbook PER BRANCH for each run: a Summary tab (branch, organisation, date range) then one tab per pharmacist with that branch's sessions, shift times, hours, rate and amounts.">
            <input type="checkbox" checked={makeXlsx} onChange={e => setMakeXlsx(e.target.checked)} />
            Also create tabbed spreadsheets (.xlsx — one per branch)
          </label>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}
            title="On the 1st of each month, automatically emails the previous month's payment schedules (both runs, one spreadsheet per branch) to the group manager. The same setting appears as 'Email locum payment schedule to group manager' in Settings.">
            <input type="checkbox" checked={!!settings.emailLocumPaymentMonthly}
              onChange={e => saveSettings({ ...settings, emailLocumPaymentMonthly: e.target.checked })} />
            Email schedules monthly
          </label>
        </div>
        <div style={{ ...S.small, marginBottom: 4 }}>
          Unconfirmed (hatched) sessions are included and marked UNCONFIRMED in the documents.
        </div>

        {/* ---- RUN 1: Locums ---- */}
        {sectionHead("1. Locum payment schedules",
          "every session worked by Locum-type pharmacists")}
        {Object.keys(locumSessions).length === 0 &&
          <div style={S.small}>No locum sessions recorded in {monthLabel}.</div>}
        {Object.keys(locumSessions).length > 0 &&
          <button style={{ ...S.btn, marginBottom: 6 }} onClick={() => downloadRun("locum")}
            title="Downloads one Word payment schedule per locum, plus one tabbed spreadsheet per branch if ticked.">
            Download all — locums{makeXlsx && locumWorkbooks.length ? ` (+ ${locumWorkbooks.length} branch spreadsheet${locumWorkbooks.length === 1 ? "" : "s"})` : ""}
          </button>}
        {Object.entries(locumSessions).map(([pid, sessions]) => runRow(pid, sessions, "locum"))}

        {/* ---- RUN 2: Additional sessions (non-locums) ---- */}
        {sectionHead("2. Additional sessions — full/part-time pharmacists",
          "out-of-schedule work only; day swaps are netted (equal hours excluded, differences paid ±) with narratives on the sheet and in each cell's log")}
        {contractedLoading &&
          <div style={{ ...S.small, color: "#92400e", marginBottom: 6 }}>
            Fetching scheduled-site opening hours for swap comparisons… downloads are enabled when this finishes.</div>}
        {!contractedLoading && Object.keys(additionalSessions).length === 0 &&
          <div style={S.small}>No additional (out-of-schedule) sessions by full/part-time pharmacists in {monthLabel}.</div>}
        {Object.keys(additionalSessions).length > 0 &&
          <button style={{ ...S.btn, marginBottom: 6, opacity: contractedLoading ? 0.5 : 1 }}
            disabled={contractedLoading}
            onClick={() => downloadRun("additional")}
            title="Downloads one Word 'Additional Sessions Payment Schedule' per full/part-time pharmacist with extra sessions, plus one tabbed spreadsheet per branch if ticked.">
            Download all — additional sessions{makeXlsx && additionalWorkbooks.length ? ` (+ ${additionalWorkbooks.length} branch spreadsheet${additionalWorkbooks.length === 1 ? "" : "s"})` : ""}
          </button>}
        {Object.entries(additionalSessions).map(([pid, sessions]) => runRow(pid, sessions, "additional"))}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Email schedules popup — pick pharmacists + weeks ahead, confirm,    */
/* then send each their personal schedule via /circulate.              */
/* ------------------------------------------------------------------ */

function EmailSchedulesPopup({ pharmacists, members, cells, ensureRange, onToast, onClose }) {
  const masked = useMaskNames();
  const [weeks, setWeeks] = useState(4);                    // full weeks ahead (from next Monday)
  const [includeCurrent, setIncludeCurrent] = useState(true); // also send the rest of THIS week
  const [sending, setSending] = useState(false);

  // window: [from, to]. Next Monday anchors the "weeks into the future";
  // includeCurrent extends the window back to today.
  const today = ymd(new Date());
  const dow = new Date(today + "T00:00:00").getDay();       // 0=Sun..6=Sat
  const nextMonday = addDays(today, ((8 - dow) % 7) || 7);
  const from = includeCurrent ? today : nextMonday;
  const to = addDays(nextMonday, weeks * 7 - 1);

  useEffect(() => { ensureRange(from, to); }, [from, to, ensureRange]);

  // sessions per pharmacist across the window
  const perPharmacist = useMemo(() => {
    const out = {};
    for (let d = from; d <= to; d = addDays(d, 1)) {
      members.forEach(m => {
        cellEntries(cells, m, d).forEach(({ pid, status }) => {
          (out[pid] = out[pid] || []).push({ date: d, pharmacy: m.pharmacyName, status });
        });
      });
    }
    return out;
  }, [cells, members, from, to]);

  const list = pharmacists
    .filter(p => p.active !== false)
    .sort((a, b) => a.name.localeCompare(b.name));

  // ALL initially checked (those without an email address can't be).
  const [included, setIncluded] = useState(() =>
    Object.fromEntries(list.map(p => [p.id, !!p.email])));

  const recipients = list
    .filter(p => included[p.id] && p.email)
    .map(p => ({ p, sessions: (perPharmacist[p.id] || []).sort((a, b) => a.date.localeCompare(b.date)) }))
    .filter(x => x.sessions.length > 0);
  const tickedNoSessions = list.filter(p =>
    included[p.id] && p.email && !(perPharmacist[p.id] || []).length).length;

  const send = async () => {
    if (sending) return;
    if (recipients.length === 0) {
      onToast("No emails to send — none of the ticked pharmacists have sessions in the selected period.");
      return;
    }
    if (!window.confirm(
      `${recipients.length} schedule email${recipients.length === 1 ? "" : "s"} will go out, covering ${prettyDate(from)} to ${prettyDate(to)}.` +
      (tickedNoSessions ? `\n(${tickedNoSessions} ticked pharmacist${tickedNoSessions === 1 ? " has" : "s have"} no sessions in this period and will be skipped.)` : "") +
      `\n\nContinue?`)) return;

    const messages = recipients.map(({ p, sessions }) => ({
      name: p.name,
      email: p.email,
      body:
        `Dear ${p.name},\n\n` +
        `Here is your schedule for ${prettyDate(from)} to ${prettyDate(to)}:\n\n` +
        sessions.map(s => `  •  ${prettyDate(s.date)} — ${s.pharmacy}${s.status === "provisional" ? " (UNCONFIRMED)" : ""}`).join("\n") +
        `\n\n${sessions.length} session${sessions.length === 1 ? "" : "s"} in total.` +
        (sessions.some(s => s.status === "provisional")
          ? "\n\nSessions marked UNCONFIRMED are provisional placements from your permanent weekly schedule and may still change."
          : "") +
        `\n\nIf anything looks incorrect, please contact the office.\n\nKind regards`
    }));

    setSending(true);
    const r = await apiPost("/circulate", {
      subject: `Your pharmacist schedule — ${prettyDate(from)} to ${prettyDate(to)}`,
      messages
    });
    setSending(false);
    if (!r.ok) { onToast(`Schedule emails failed: ${r.error}`); return; }
    const { sent, failed } = r.data;
    onToast(failed
      ? `Schedules: ${sent} sent, ${failed} FAILED — see Email history for detail.`
      : `Schedules sent — ${sent} personalised email${sent === 1 ? "" : "s"} (recorded in Email history).`);
    onClose();
  };

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 720 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Email schedules now</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>

        <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
            Send schedules for the next
            <select style={S.select} value={weeks} onChange={e => setWeeks(Number(e.target.value))}>
              {[1, 2, 3, 4, 5, 6, 7, 8].map(w => <option key={w} value={w}>{w}</option>)}
            </select>
            week{weeks > 1 ? "s" : ""}
          </label>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}
            title="Also include the remaining days of the current week (from today).">
            <input type="checkbox" checked={includeCurrent} onChange={e => setIncludeCurrent(e.target.checked)} />
            Include the current week
          </label>
          <span style={S.small}>{prettyDate(from)} → {prettyDate(to)}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Recipients</span>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}
            title="Tick or untick every pharmacist in the list at once.">
            <input type="checkbox"
              checked={list.filter(p => p.email).length > 0 && list.filter(p => p.email).every(p => !!included[p.id])}
              onChange={e => {
                const v = e.target.checked;
                setIncluded(Object.fromEntries(list.map(p => [p.id, v && !!p.email])));
              }} />
            Select all
          </label>
        </div>
        <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, maxHeight: 320, overflowY: "auto" }}>
          {list.map(p => {
            const n = (perPharmacist[p.id] || []).length;
            return (
              <label key={p.id} style={{
                display: "flex", gap: 8, alignItems: "center", padding: "6px 10px",
                borderBottom: "1px solid #f3f4f6", fontSize: 13,
                cursor: p.email ? "pointer" : "not-allowed", opacity: p.email ? 1 : 0.6
              }}>
                <input type="checkbox" disabled={!p.email} checked={!!included[p.id]}
                  onChange={e => setIncluded({ ...included, [p.id]: e.target.checked })} />
                <b>{displayName(p.name, masked)}</b>
                <span style={{
                  ...S.tag, marginLeft: 0,
                  background: p.type === "Locum" ? "#d1fae5" : "#dbeafe",
                  color: p.type === "Locum" ? "#065f46" : "#1e40af"
                }}>{p.type}</span>
                <span style={S.small}>{p.email || "no email address"}</span>
                <span style={{
                  ...S.tag, marginLeft: "auto",
                  background: n ? "#d1fae5" : "#f3f4f6",
                  color: n ? "#065f46" : "#6b7280"
                }}>{n} session{n === 1 ? "" : "s"}</span>
              </label>
            );
          })}
          {list.length === 0 && <div style={{ padding: 10, fontSize: 13, color: "#6b7280" }}>No active pharmacists in the register.</div>}
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 14, alignItems: "center" }}>
          <button style={{ ...S.btnGreen, opacity: sending ? 0.6 : 1 }} disabled={sending} onClick={send}
            title="Shows a confirmation with the exact number of emails, then sends one personalised schedule per ticked pharmacist. Every email is recorded in Email history.">
            {sending ? "Sending…" : `Send (${recipients.length})`}</button>
          <span style={S.small}>
            Pharmacists with no sessions in the period are skipped automatically; those without an email address cannot be selected.
          </span>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Email history popup — every email the rota has ever sent, from the  */
/* unified rota_email_logs collection. Click a row to read the email.  */
/* ------------------------------------------------------------------ */

function EmailHistoryPopup({ onToast, onClose }) {
  const masked = useMaskNames();
  const [rows, setRows] = useState(null);   // null = loading
  const [selIdx, setSelIdx] = useState(null);

  useEffect(() => {
    (async () => {
      const r = await apiGet("/emails?limit=300");
      setRows(r.ok ? r.data.emails : []);
      if (!r.ok) onToast(r.error);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const SOURCE_LABEL = {
    "circulate": "circulation / schedule / booking",
    "weekly-schedule": "auto weekly schedule",
    "cover-report": "cover report"
  };

  const sel = selIdx !== null && rows ? rows[selIdx] : null;

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 980 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>Email history</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>
        <div style={{ ...S.small, marginBottom: 10 }}>
          Every email sent from the rota — on-demand schedules, circulations, locum booking
          confirmations, the Thursday auto weekly schedules and manager cover reports.
          Click an email to read its content.
        </div>
        <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
          {/* Left: email list */}
          <div style={{ flex: "0 0 46%", maxHeight: 420, overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: 6 }}>
            {rows === null && <div style={{ padding: 10, fontSize: 13, color: "#6b7280" }}>Loading…</div>}
            {rows !== null && rows.length === 0 &&
              <div style={{ padding: 10, fontSize: 13, color: "#6b7280" }}>
                No emails recorded yet. (Logging starts from this version — emails sent before the upgrade appear only in the circulation log.)</div>}
            {(rows || []).map((e, i) => (
              <div key={i} onClick={() => setSelIdx(i)}
                style={{
                  padding: "7px 10px", cursor: "pointer", borderBottom: "1px solid #f3f4f6", fontSize: 12.5,
                  background: selIdx === i ? "#dbeafe" : "transparent"
                }}>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  <b style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {displayName(e.name || e.to, masked)}</b>
                  <span style={{
                    ...S.tag,
                    background: e.status === "sent" ? "#d1fae5" : "#fee2e2",
                    color: e.status === "sent" ? "#065f46" : "#991b1b"
                  }}>{e.status}</span>
                  <span style={{ ...S.small, marginLeft: "auto", whiteSpace: "nowrap" }}>
                    {new Date(e.sentAt).toLocaleString("en-GB")}</span>
                </div>
                <div style={{ ...S.small, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {e.subject}</div>
              </div>
            ))}
          </div>
          {/* Right: email content */}
          <div style={{ flexGrow: 1, minWidth: 0 }}>
            {!sel && <div style={S.small}>Select an email on the left to view its content.</div>}
            {sel && (
              <div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{sel.subject}</div>
                <div style={{ ...S.small, margin: "4px 0 2px" }}>
                  To: {displayName(sel.name || "", masked)} &lt;{masked ? "…" : sel.to}&gt;
                  {" — "}{new Date(sel.sentAt).toLocaleString("en-GB")}
                </div>
                <div style={{ ...S.small, marginBottom: 8 }}>
                  Sent by {sel.sentBy} · {SOURCE_LABEL[sel.source] || sel.source}
                  {sel.error && <span style={{ color: "#dc2626" }}> · error: {sel.error}</span>}
                </div>
                <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: 13, background: "#f9fafb", padding: 10, borderRadius: 6, border: "1px solid #e5e7eb", maxHeight: 340, overflowY: "auto" }}>
                  {sel.body || "(body not recorded)"}</pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* "How to use this module" popup — static help text                   */
/* ------------------------------------------------------------------ */

function HelpPopup({ onClose }) {
  const h = { fontWeight: 700, fontSize: 14, margin: "14px 0 4px" };
  const p = { fontSize: 13.5, lineHeight: 1.55, margin: "0 0 6px" };
  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, width: 760 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={S.modalTitle}>How to use this module</h3>
          <button style={S.btnGhost} onClick={onClose}>Close</button>
        </div>

        <div style={{ ...h, marginTop: 0 }}>1. Create your pharmacist list</div>
        <p style={p}>
          First of all create a list of your pharmacists — click <b>Pharmacist list</b> and create an
          entry for each pharmacist. Indicate whether they are locums or permanent, and optionally
          what days they are regularly scheduled to work at which branch — this can be changed later,
          but will make completing the rota much quicker.
        </p>

        <div style={h}>2. Completing the rota</div>
        <p style={p}>
          The rota will display up to six months in advance. Using your pharmacist schedules, it will
          automatically suggest pharmacists at each site. You can <b>confirm</b> suggested bookings by
          double-clicking the cell, or confirm all for the month in view by clicking <b>Confirm all</b>.
          Any changes, or unbooked sites, can be assigned a pharmacist by clicking that cell and
          choosing a name.
        </p>

        <div style={h}>3. Emails</div>
        <p style={p}>
          a) The system automatically sends out a schedule to each pharmacist every Wednesday night
          for the following week.<br />
          b) The system automatically sends an email to the manager on Wednesday night if any sites
          are uncovered the following week.<br />
          c) At any time you can optionally send out a schedule to one or more pharmacists, for a
          selectable number of weeks in the future (<b>Email schedules now</b>).<br />
          d) At any time you can optionally send out an email to all available pharmacists to try and
          cover unbooked sessions (<b>Send emails to pharmacists to find cover</b>).<br />
          e) When assigning a locum you will be prompted if you want to send a confirmatory email.
        </p>

        <div style={h}>4. Logs</div>
        <p style={p}>
          Each cell has a log history so you can view changes made to it — click the cell to view it.
          A log of circulation emails, sent to find locums to fill vacancies, is available
          (<b>Circulation log</b>). An email log is also kept of all emails sent out to staff
          (<b>Email history</b>).
        </p>

        <div style={h}>5. Monthly payments (locums + additional sessions)</div>
        <p style={p}>
          Click <b>Payment summaries</b> to generate and download two payment runs for any month:
          <b> (1) Locums</b> — every session worked by Locum-type pharmacists; and
          <b> (2) Additional sessions</b> — full/part-time pharmacists, counting <b>only</b> sessions
          outside their permanent weekly schedule (their normal scheduled days are excluded, so only
          extra work is paid). <b>Day swaps are netted:</b> if a pharmacist works a different site
          from their scheduled one and the hours are <b>equal</b>, the day is excluded from pay and
          an explanatory entry is written to that cell's change log; if the hours differ, the
          <b> signed difference</b> appears on the schedule (a negative figure is a deduction), with
          a <b>Narrative column</b> explaining contracted vs worked hours and the same narrative in
          the cell's log. Both runs use: a) the <b>hours on site recorded on each session</b>,
          and b) the hourly rate set in each pharmacist's profile (now editable for every type, not
          just locums). When a pharmacist is first booked into a cell, that pharmacy's opening hours
          for the day — including split days with two or more shifts — are captured and stored on
          the session; open the cell to view or <b>edit the shift times</b> (e.g. the pharmacist
          arrived late). A session with <b>no recorded times has its hours and amount left empty</b>
          in every document — there is no fallback calculation. Tabbed spreadsheets are produced
          <b> one per branch</b> for each run.
        </p>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Main component                                                      */
/* ------------------------------------------------------------------ */

export default function PharmacistRota() {
  const masked = useMaskNames();
  const members = useMemo(() => {
    try {
      return (JSON.parse(localStorage.getItem("members") || "[]"))
        .filter(m => m && m.pharmacyName)
        .sort((a, b) => a.pharmacyName.localeCompare(b.pharmacyName));
    } catch (e) { return []; }
  }, []);

  const [pharmacists, setPharmacists] = useState(null);       // null = loading
  const [cells, setCells] = useState(new Map());              // cellKey -> {assigned, provisional}
  const [settings, setSettings] = useState({ autoEmailWeekly: false, coverFailureEmail: true, emailLocumPaymentMonthly: false });
  const [loadedRange, setLoadedRange] = useState(null);       // {from, to} covered by `cells`
  const [loadError, setLoadError] = useState(null);
  const [pendingOps, setPendingOps] = useState(0);            // in-flight mutations
  const [opError, setOpError] = useState(null);               // last mutation failure
  const [toast, setToast] = useState(null);

  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth());         // 0-based
  const [openCell, setOpenCell] = useState(null);             // {dateStr, pharmacyName}
  const [showList, setShowList] = useState(false);
  const [uncoveredMonths, setUncoveredMonths] = useState(1);
  const [uncoveredOpen, setUncoveredOpen] = useState(false);
  const [circulateDays, setCirculateDays] = useState(14);   // circulation window in DAYS, from tomorrow
  const [showCirculate, setShowCirculate] = useState(false);
  const [showCircLog, setShowCircLog] = useState(false);
  const [showSummaries, setShowSummaries] = useState(false);   // locum payment summaries dialogue
  const [confirmingAll, setConfirmingAll] = useState(false);   // "Confirm all" (this month) in flight
  const [showEmailSchedules, setShowEmailSchedules] = useState(false);   // "Email schedules now" dialogue
  const [showEmailHistory, setShowEmailHistory] = useState(false);       // "Email history" dialogue
  const [showHelp, setShowHelp] = useState(false);                       // "How to use this module" popup
  const rangeRef = useRef(null);                              // mirrors loadedRange for callbacks

  const onToast = useCallback((msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 5000);
  }, []);

  /* ---- cell range loading -----------------------------------------
     Cells are fetched by date range. ensureRange() widens the loaded
     window when the UI needs dates outside it (month navigation, the
     uncovered panel, circulation, summaries) and refetches the union
     range in one query — loads scale with the window, never with
     total history. */
  // Ensure every current/future month in [from, to] has been POPULATED from
  // the permanent schedules before reading cells. The server is exactly-once
  // per (org, month) via a ledger; on top of that we remember which months
  // this session has already requested (materialisedRef) so month navigation
  // doesn't re-send the whole range, and we CHUNK requests to 12 months per
  // call (the server's hard cap — exceeding it is an HTTP 500).
  const materialisedRef = useRef(new Set());
  const materialiseMonths = useCallback(async (from, to) => {
    const thisMonth = ymd(new Date()).slice(0, 7);
    const horizonMonth = addMonths(ymd(new Date()), 6).slice(0, 7);   // population capped at +6 months
    const keys = [];
    for (let mk = from.slice(0, 7); mk <= to.slice(0, 7); mk = addMonths(mk + "-01", 1).slice(0, 7)) {
      if (mk >= thisMonth && mk <= horizonMonth && !materialisedRef.current.has(mk)) keys.push(mk);
    }
    for (let i = 0; i < keys.length; i += 12) {
      const batch = keys.slice(i, i + 12);
      const r = await apiPost("/materialise", { monthKeys: batch });
      if (!r.ok) { setOpError(r.error); return; }   // non-fatal: cells still load, just unpopulated
      batch.forEach(k => materialisedRef.current.add(k));   // only remember successes
    }
  }, []);

  const fetchCells = useCallback(async (from, to) => {
    await materialiseMonths(from, to);
    const r = await apiGet(`/cells?from=${from}&to=${to}`);
    if (!r.ok) { setOpError(r.error); return false; }
    const map = new Map();
    (r.data.cells || []).forEach(c =>
      map.set(cellKey(c.date, c.pharmacyName),
        {
          assigned: c.assigned || [], provisional: c.provisional || [],
          note: c.note || "",
          shifts: Array.isArray(c.shifts) ? c.shifts : undefined   // v29 — hours on site
        }));
    setCells(map);
    const range = { from, to };
    rangeRef.current = range;
    setLoadedRange(range);
    return true;
  }, [materialiseMonths]);

  const ensureRange = useCallback((from, to) => {
    const cur = rangeRef.current;
    if (cur && cur.from <= from && cur.to >= to) return;
    const nf = cur && cur.from < from ? cur.from : from;
    const nt = cur && cur.to > to ? cur.to : to;
    fetchCells(nf, nt);
  }, [fetchCells]);

  /* ---- initial load ---- */
  const load = useCallback(async () => {
    setLoadError(null);
    setPharmacists(null);
    // Purge any rota data written to localStorage by earlier beta builds.
    try { localStorage.removeItem(LEGACY_LS_KEY); } catch (e) { /* ignore */ }

    const [pRes, sRes] = await Promise.all([apiGet("/pharmacists"), apiGet("/settings")]);
    if (!pRes.ok) { setLoadError(pRes.error); return; }
    if (!sRes.ok) { setLoadError(sRes.error); return; }

    // initial cell window: this month, plus 3 months forward from today
    // (covers the uncovered panel's maximum and the circulation window)
    const monthStart = ymd(new Date(now.getFullYear(), now.getMonth(), 1));
    const from = monthStart < ymd(now) ? monthStart : ymd(now);
    const to = addMonths(ymd(now), 3);
    const ok = await fetchCells(from, to);
    if (!ok) { setLoadError(opErrorRefSafe()); return; }

    setPharmacists(pRes.data.pharmacists || []);
    setSettings(sRes.data.settings || { autoEmailWeekly: false, coverFailureEmail: true, emailLocumPaymentMonthly: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCells]);

  // fetchCells sets opError on failure; read it safely for the load path.
  const opErrorRef = useRef(null);
  useEffect(() => { opErrorRef.current = opError; }, [opError]);
  function opErrorRefSafe() { return opErrorRef.current || "cell load failed"; }

  useEffect(() => { load(); }, [load]);

  /* ---- widen the window when the UI needs it ---- */
  useEffect(() => {
    if (!loadedRange) return;
    const monthStart = ymd(new Date(year, month, 1));
    const monthEnd = ymd(new Date(year, month + 1, 0));
    const today = ymd(new Date());
    const horizon = addMonths(today, Math.max(uncoveredMonths, 1));
    const from = monthStart < today ? monthStart : today;
    const to = monthEnd > horizon ? monthEnd : horizon;
    ensureRange(from, to);
  }, [year, month, uncoveredMonths, ensureRange, loadedRange]);

  /* ---- atomic cell mutation with optimistic local update ----
     v29: the request also carries the member's pharmacyId so the server
     can look the branch up in pharmace_common_db.pharmacies — on the
     FIRST add/confirm for a cell it stores that day's opening shifts on
     the cell and returns the updated cell, which is merged in here so
     the shifts appear immediately (no refetch). */
  const mutateCell = useCallback(async (date, pharmacyName, action, pid, logDetail) => {
    const key = cellKey(date, pharmacyName);
    // optimistic update
    setCells(prev => {
      const next = new Map(prev);
      const cell = {
        assigned: [...(prev.get(key)?.assigned || [])],
        provisional: [...(prev.get(key)?.provisional || [])],
        note: prev.get(key)?.note || "",
        shifts: prev.get(key)?.shifts
      };
      if (action === "add") {
        if (!cell.assigned.includes(pid)) cell.assigned.push(pid);
        cell.provisional = cell.provisional.filter(x => x !== pid);
      } else if (action === "remove") {
        cell.assigned = cell.assigned.filter(x => x !== pid);
        cell.provisional = cell.provisional.filter(x => x !== pid);
      } else if (action === "confirm") {
        cell.provisional = cell.provisional.filter(x => x !== pid);
        if (!cell.assigned.includes(pid)) cell.assigned.push(pid);
      }
      if (!cell.assigned.length && !cell.provisional.length && !cell.note) next.delete(key);
      else next.set(key, cell);
      return next;
    });

    const member = members.find(m => m.pharmacyName === pharmacyName);
    setPendingOps(n => n + 1);
    const r = await apiPost("/cells/mutate", {
      date, pharmacyName,
      pharmacyId: member?.pharmacyId ?? member?._id ?? null,   // for the pharmacies lookup
      pharmacistId: pid, action, logDetail
    });
    setPendingOps(n => n - 1);
    if (!r.ok) {
      setOpError(r.error);
      onToast(`Save failed — reloading from server. ${r.error}`);
      const cur = rangeRef.current;
      if (cur) fetchCells(cur.from, cur.to);   // revert to server truth
      return false;
    }
    setOpError(null);
    // v29 server returns the updated cell — merge stored shifts into state
    const returned = r.data && r.data.cell;
    if (returned && Array.isArray(returned.shifts)) {
      setCells(prev => {
        const cur = prev.get(key);
        if (!cur) return prev;
        const next = new Map(prev);
        next.set(key, { ...cur, shifts: returned.shifts });
        return next;
      });
    }
    return true;
  }, [fetchCells, onToast, members]);

  /* ---- per-cell note (v28) — persisted on the cell doc; every change is
     appended to the cell's change log server-side. */
  const saveCellNote = useCallback(async (date, pharmacyName, note) => {
    const key = cellKey(date, pharmacyName);
    // optimistic
    setCells(prev => {
      const next = new Map(prev);
      const cell = {
        assigned: [...(prev.get(key)?.assigned || [])],
        provisional: [...(prev.get(key)?.provisional || [])],
        note
      };
      if (!cell.assigned.length && !cell.provisional.length && !note) next.delete(key);
      else next.set(key, cell);
      return next;
    });
    setPendingOps(n => n + 1);
    const r = await apiPost("/cells/note", { date, pharmacyName, note });
    setPendingOps(n => n - 1);
    if (!r.ok) {
      setOpError(r.error);
      onToast(`Note save failed — reloading from server. ${r.error}`);
      const cur = rangeRef.current;
      if (cur) fetchCells(cur.from, cur.to);
      return false;
    }
    setOpError(null);
    return true;
  }, [fetchCells, onToast]);

  /* ---- per-cell shifts (v29) — hours on site, user-editable.
     Replaces the shifts stored on the cell (originally captured from the
     pharmacy's opening hours when the session was first booked); the
     change is appended to the cell's log server-side. */
  const saveCellShifts = useCallback(async (date, pharmacyName, shifts) => {
    const key = cellKey(date, pharmacyName);
    const clean = (shifts || [])
      .map(sh => ({ start: String(sh.start || "").slice(0, 5), end: String(sh.end || "").slice(0, 5) }))
      .filter(sh => shiftMins(sh.start) !== null && shiftMins(sh.end) !== null && shiftMins(sh.end) > shiftMins(sh.start));
    // optimistic
    setCells(prev => {
      const cur = prev.get(key);
      const next = new Map(prev);
      next.set(key, {
        assigned: [...(cur?.assigned || [])],
        provisional: [...(cur?.provisional || [])],
        note: cur?.note || "",
        shifts: clean
      });
      return next;
    });
    setPendingOps(n => n + 1);
    const r = await apiPost("/cells/shifts", { date, pharmacyName, shifts: clean });
    setPendingOps(n => n - 1);
    if (!r.ok) {
      setOpError(r.error);
      onToast(`Hours save failed — reloading from server. ${r.error}`);
      const cur = rangeRef.current;
      if (cur) fetchCells(cur.from, cur.to);
      return false;
    }
    setOpError(null);
    return true;
  }, [fetchCells, onToast]);

  /* ---- pharmacist CRUD ---- */
  const createPharmacist = useCallback(async (form) => {
    setPendingOps(n => n + 1);
    const r = await apiPost("/pharmacists", { pharmacist: form });
    setPendingOps(n => n - 1);
    if (!r.ok) { setOpError(r.error); onToast(`Create failed: ${r.error}`); return null; }
    setOpError(null);
    setPharmacists(prev => [...(prev || []), r.data.pharmacist]);
    return r.data.pharmacist;
  }, [onToast]);

  const updatePharmacist = useCallback(async (id, fields) => {
    // optimistic
    setPharmacists(prev => (prev || []).map(p => (p.id === id ? { ...p, ...fields } : p)));
    setPendingOps(n => n + 1);
    const r = await apiPost(`/pharmacists/${encodeURIComponent(id)}/update`, { pharmacist: fields });
    setPendingOps(n => n - 1);
    if (!r.ok) {
      setOpError(r.error);
      onToast(`Update failed: ${r.error}`);
      const pr = await apiGet("/pharmacists");    // revert to server truth
      if (pr.ok) setPharmacists(pr.data.pharmacists || []);
      return false;
    }
    setOpError(null);
    setPharmacists(prev => (prev || []).map(p => (p.id === id ? r.data.pharmacist : p)));
    // A weekly-pattern change syncs the unconfirmed layer server-side —
    // report what it did and reload the grid so the changes are visible.
    const sync = r.data.patternSync;
    if (fields.weeklyPattern !== undefined && sync && (sync.added || sync.removed)) {
      onToast(`Permanent schedule updated: ${sync.added} unconfirmed placement${sync.added === 1 ? "" : "s"} added, ${sync.removed} removed (confirmed entries untouched).`);
      const cur = rangeRef.current;
      if (cur) fetchCells(cur.from, cur.to);
    }
    return true;
  }, [onToast, fetchCells]);

  const deletePharmacist = useCallback(async (id) => {
    setPendingOps(n => n + 1);
    const r = await apiPost(`/pharmacists/${encodeURIComponent(id)}/delete`, {});
    setPendingOps(n => n - 1);
    if (!r.ok) { setOpError(r.error); onToast(`Delete failed: ${r.error}`); return; }
    setOpError(null);
    setPharmacists(prev => (prev || []).filter(p => p.id !== id));
  }, [onToast]);

  /* ---- settings ---- */
  const saveSettings = useCallback(async (next) => {
    setSettings(next);
    setPendingOps(n => n + 1);
    const r = await apiPost("/settings/save", { settings: next });
    setPendingOps(n => n - 1);
    if (!r.ok) { setOpError(r.error); onToast(`Setting save failed: ${r.error}`); return; }
    setOpError(null);
    onToast("Setting saved.");
  }, [onToast]);

  /* ---- derived data ---- */
  const byId = useMemo(
    () => Object.fromEntries((pharmacists || []).map(p => [p.id, p])),
    [pharmacists]
  );

  const days = useMemo(() => {
    const out = [];
    const last = new Date(year, month + 1, 0).getDate();
    for (let d = 1; d <= last; d++) {
      const date = new Date(year, month, d);
      out.push({ dateStr: ymd(date), dayNum: d, dow: DAY_NAMES[date.getDay()] });
    }
    return out;
  }, [year, month]);

  const cellInfo = useCallback((member, dateStr) => {
    if (!isOpen(member, dateStr)) return { status: "closed", entries: [] };
    const entries = cellEntries(cells, member, dateStr);
    if (entries.length === 0) return { status: "uncovered", entries };
    const hasNonLocum = entries.some(e => byId[e.pid] && byId[e.pid].type !== "Locum");
    return { status: hasNonLocum ? "covered" : "locumOnly", entries };
  }, [cells, byId]);

  /* ---- per-day row status for the date-label highlight ----
     red    = the same pharmacist is placed at MORE THAN ONE open site on
              that date (confirmed or unconfirmed — either way they cannot
              be in two places at once)
     amber  = at least one open site has NO pharmacist assigned at all
     green  = every open site is covered and no pharmacist is double-booked
     (red wins over amber when both problems exist on the same date) */
  const dayStatus = useCallback((dateStr) => {
    const siteCount = new Map();          // pid -> number of open sites that day
    let anyOpen = false, uncovered = false, conflict = false;
    members.forEach(m => {
      if (!isOpen(m, dateStr)) return;
      anyOpen = true;
      const entries = cellEntries(cells, m, dateStr);
      if (entries.length === 0) uncovered = true;
      new Set(entries.map(e => e.pid)).forEach(pid => {
        const n = (siteCount.get(pid) || 0) + 1;
        siteCount.set(pid, n);
        if (n > 1) conflict = true;
      });
    });
    if (!anyOpen) return "none";
    if (conflict) return "conflict";
    if (uncovered) return "uncovered";
    return "ok";
  }, [cells, members]);

  /* Set of pharmacist ids placed at MORE THAN ONE open site on a date
     (confirmed or provisional). Used to paint their name red in EVERY
     cell they appear in that day. */
  const conflictedPids = useCallback((dateStr) => {
    const siteCount = new Map();
    members.forEach(m => {
      if (!isOpen(m, dateStr)) return;
      new Set(cellEntries(cells, m, dateStr).map(e => e.pid))
        .forEach(pid => siteCount.set(pid, (siteCount.get(pid) || 0) + 1));
    });
    return new Set([...siteCount.entries()].filter(([, n]) => n > 1).map(([pid]) => pid));
  }, [cells, members]);

  const uncoveredBetween = useCallback((fromStr, toStr) => {
    const out = [];
    for (let d = fromStr; d <= toStr; d = addDays(d, 1)) {
      members.forEach(m => {
        if (isOpen(m, d) && cellEntries(cells, m, d).length === 0)
          out.push({ date: d, pharmacy: m.pharmacyName });
      });
    }
    return out;
  }, [cells, members]);

  const uncoveredSessionsMonths = useMemo(() => {
    const from = ymd(new Date());
    return uncoveredBetween(from, addDays(addMonths(from, uncoveredMonths), -1));
  }, [uncoveredBetween, uncoveredMonths]);

  const uncoveredSessionsCirculate = useMemo(() => {
    const from = addDays(ymd(new Date()), 1);   // from and including tomorrow
    return uncoveredBetween(from, addDays(from, circulateDays - 1));
  }, [uncoveredBetween, circulateDays]);

  const monthStats = useMemo(() => {
    if (!pharmacists) return { open: 0, covered: 0, uncovered: 0, unconfirmed: 0 };
    let open = 0, covered = 0, unconfirmed = 0;
    days.forEach(day => members.forEach(m => {
      const { status, entries } = cellInfo(m, day.dateStr);
      if (status !== "closed") {
        open++;
        if (status !== "uncovered") covered++;
        if (entries.some(e => e.status === "provisional")) unconfirmed++;
      }
    }));
    return { open, covered, uncovered: open - covered, unconfirmed };
  }, [pharmacists, days, members, cellInfo]);

  /* ---- click vs double-click on grid cells --------------------------
     Single click (after a short delay) opens the cell popup; double-click
     confirms every unconfirmed placement in the cell. The delay lets the
     double-click cancel the pending single-click. */
  const clickTimer = useRef(null);
  const clickCell = (dateStr, pharmacyName) => {
    clearTimeout(clickTimer.current);
    clickTimer.current = setTimeout(() => setOpenCell({ dateStr, pharmacyName }), 250);
  };
  const dblClickCell = async (dateStr, pharmacyName, entries) => {
    clearTimeout(clickTimer.current);
    const provisional = entries.filter(e => e.status === "provisional").map(e => e.pid);
    if (!provisional.length) { setOpenCell({ dateStr, pharmacyName }); return; }
    for (const pid of provisional) {
      const p = byId[pid];
      await mutateCell(dateStr, pharmacyName, "confirm", pid, `${p ? p.name : pid} confirmed (double-click)`);
    }
    onToast(`${provisional.length} placement${provisional.length > 1 ? "s" : ""} confirmed — ${pharmacyName}, ${prettyDate(dateStr)}.`);
  };

  /* ---- "Confirm all" (visible month) ------------------------------
     Exactly equivalent to double-clicking every cell in the month that
     contains unconfirmed placements: each provisional entry is confirmed
     one by one through the same mutateCell path (optimistic update +
     per-cell change log), then the grid is refetched from the server. */
  const monthProvisionals = useMemo(() => {
    const out = [];
    days.forEach(day => members.forEach(m => {
      const cell = cells.get(cellKey(day.dateStr, m.pharmacyName));
      (cell?.provisional || []).forEach(pid =>
        out.push({ date: day.dateStr, pharmacy: m.pharmacyName, pid }));
    }));
    return out;
  }, [days, members, cells]);

  const confirmAllMonth = async () => {
    if (confirmingAll) return;
    if (monthProvisionals.length === 0) {
      onToast(`Nothing to confirm — ${monthLabel} has no unconfirmed (hatched) placements.`);
      return;
    }
    if (!window.confirm(
      `Confirm all ${monthProvisionals.length} suggested assignment${monthProvisionals.length === 1 ? "" : "s"} for ${monthLabel}?\n\n` +
      `These were entered automatically from each pharmacist's normal weekly pattern. ` +
      `Confirming them is the same as double-clicking every hatched cell in this month.`)) return;
    setConfirmingAll(true);
    let done = 0;
    for (const { date, pharmacy, pid } of monthProvisionals) {
      const p = byId[pid];
      const ok = await mutateCell(date, pharmacy, "confirm", pid,
        `${p ? p.name : pid} confirmed (Confirm all — ${monthLabel})`);
      if (!ok) break;   // mutateCell has already toasted and reloaded from server
      done++;
    }
    // refresh the display from server truth
    const cur = rangeRef.current;
    if (cur) await fetchCells(cur.from, cur.to);
    setConfirmingAll(false);
    onToast(`${done} of ${monthProvisionals.length} suggested placement${monthProvisionals.length === 1 ? "" : "s"} confirmed for ${monthLabel}.`);
  };

  /* ---- "Email schedules now" -----------------------------------------
     Opens EmailSchedulesPopup: pick pharmacists (all ticked by default),
     choose how many weeks ahead (optionally including the rest of the
     current week), then Send → confirmation popup → personalised emails
     via /circulate (which also writes each one to rota_email_logs). */

  /* ---- render ---- */
  if (loadError) return (
    <div style={S.wrap}>
      <div style={{ ...S.panel, borderLeft: "4px solid #dc2626" }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: "#dc2626", marginBottom: 6 }}>
          Cannot reach the rota server — nothing can be loaded or saved.
        </div>
        <div style={{ fontSize: 13, marginBottom: 10, fontFamily: "monospace" }}>{loadError}</div>
        <div style={{ ...S.small, marginBottom: 10 }}>
          This page stores data only on the server (pharmace_common_db: rota_pharmacists,
          rota_cells, rota_logs, rota_settings, rota_materialised, rota_circulation_logs).
          There is no local fallback.
        </div>
        <button style={S.btn} onClick={load}>Retry</button>
      </div>
    </div>
  );

  if (!pharmacists) return (
    <div style={S.wrap}>
      Loading rota…
    </div>
  );

  const monthLabel = `${MONTH_NAMES[month]} ${year}`;

  const horizonMonthKey = addMonths(ymd(new Date()), 6).slice(0, 7);
  const nextMonthKey = ymd(new Date(year, month + 1, 1)).slice(0, 7);
  const atHorizon = nextMonthKey > horizonMonthKey;

  const shiftMonth = (delta) => {
    const d = new Date(year, month + delta, 1);
    if (delta > 0 && ymd(d).slice(0, 7) > horizonMonthKey) return;   // hard cap: 6 months ahead
    setYear(d.getFullYear()); setMonth(d.getMonth());
  };

  return (
    <div style={S.wrap}>

      {/* ---- Header row: title + Pharmacist list (top left) + op status ---- */}
      <div style={S.headRow}>
        <h1 style={S.h1}>Pharmacist rota</h1>
        <button style={S.btn} onClick={() => setShowList(true)}
          title="The full pharmacist register: name, GPhC number, contact details, type (full-time / part-time / locum), an Active switch, and each pharmacist's permanent weekly days. Inactive pharmacists are hidden from pick lists and receive no emails.">
          Pharmacist list ({pharmacists.filter(p => p.active !== false).length} active / {pharmacists.length})
        </button>
        <span style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 8, cursor: "help" }}
          title="Live save status. Every change is written straight to the server — there is no local storage. If a save fails, the error appears here and the grid reloads from the server so you never work from stale data.">
          {pendingOps > 0 && <span style={{ color: "#92400e" }}>Saving…</span>}
          {pendingOps === 0 && !opError && <span style={{ color: "#059669" }}>All changes saved to server ✓</span>}
          {pendingOps === 0 && opError && (
            <span style={{ color: "#dc2626", fontWeight: 600 }}>⚠ Last save failed: {opError}</span>
          )}
        </span>
        <button style={{ ...S.btnGhost, marginLeft: "auto" }} onClick={() => setShowHelp(true)}
          title="A step-by-step guide to setting up pharmacists, completing the rota, emails, logs and locum payments.">
          How to use this module</button>
      </div>

      {/* ---- Uncovered sessions panel (+ circulation controls on the same line) ---- */}
      <div style={{ ...S.panel, borderLeft: uncoveredSessionsMonths.length ? "4px solid #dc2626" : "4px solid #059669" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", flexWrap: "wrap" }}
          onClick={() => setUncoveredOpen(v => !v)}
          title="Counts every open session from today with no cover at all — neither confirmed nor unconfirmed. Click to expand the list and assign a locum to any session directly.">
          <b style={{ fontSize: 14 }}>Uncovered sessions over the next</b>
          <select style={S.select} value={uncoveredMonths}
            onClick={e => e.stopPropagation()}
            onChange={e => setUncoveredMonths(Number(e.target.value))}>
            <option value={1}>1 month</option>
            <option value={2}>2 months</option>
            <option value={3}>3 months</option>
          </select>
          <span style={{
            fontWeight: 700, fontSize: 15,
            color: uncoveredSessionsMonths.length ? "#dc2626" : "#059669"
          }}>{uncoveredSessionsMonths.length}</span>
          <span style={{ fontSize: 13, color: "#6b7280" }}>{uncoveredOpen ? "▲ hide" : "▼ show list"}</span>

          {/* right-hand controls — clicks here must not toggle the list */}
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", cursor: "default" }}
            onClick={e => e.stopPropagation()}>
            <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "help" }}
              title="Opens an editable email listing every unfilled session over the chosen number of days, starting tomorrow. Every active pharmacist (full-time, part-time and locum) can be included, each receiving a PERSONALISED version containing only the sessions they are free to work; you choose the recipients before sending.">
              <button style={S.btn} onClick={() => setShowCirculate(true)}>
                Send emails to pharmacists to find cover where needed for next</button>
              <select style={S.select} value={circulateDays} onChange={e => setCirculateDays(Number(e.target.value))}>
                {[3, 5, 7, 10, 14, 21, 28].map(d => <option key={d} value={d}>{d}</option>)}
              </select>
              days (from and including tomorrow)
            </label>
            <button style={S.btnGhost} onClick={() => setShowCircLog(true)}
              title="Every previous locum circulation — dates, recipients, delivery status and the exact email each locum received.">
              Circulation log</button>
            <button style={S.btnGhost} onClick={() => setShowSummaries(true)}
              title="For any month, generates TWO payment runs: (1) locums — every session worked; (2) full/part-time pharmacists — only their ADDITIONAL sessions outside their permanent weekly schedule. Word docs plus one spreadsheet per branch, downloaded locally for review — never emailed.">
              Payment summaries</button>
          </div>
        </div>

        {uncoveredOpen && (
          <div style={{ marginTop: 10, maxHeight: 260, overflowY: "auto" }}>
            {uncoveredSessionsMonths.length === 0 &&
              <div style={S.small}>All open sessions are covered in this period 🎉</div>}
            {uncoveredSessionsMonths.map((s, i) => (
              <div key={i} style={{ display: "flex", gap: 10, alignItems: "center", padding: "4px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13 }}>
                <span style={{ minWidth: 150 }}>{prettyDate(s.date)}</span>
                <button style={S.btn}
                  title="Opens the same assignment dialogue as clicking this session's cell in the grid."
                  onClick={() => setOpenCell({ dateStr: s.date, pharmacyName: s.pharmacy })}>Assign</button>
                <b style={{ flexGrow: 1 }}>{s.pharmacy}</b>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ---- Toolbar ---- */}
      <div style={S.toolbar}>
        <button style={S.btnGhost} onClick={() => shiftMonth(-1)} title="Previous month">◀ Prev</button>
        <b style={{ fontSize: 16, minWidth: 160, textAlign: "center" }}>{monthLabel}</b>
        <button style={{ ...S.btnGhost, opacity: atHorizon ? 0.45 : 1, cursor: atHorizon ? "not-allowed" : "pointer" }}
          disabled={atHorizon} onClick={() => shiftMonth(1)}
          title={atHorizon
            ? "Navigation is limited to 6 months ahead of today — further months become available as time moves on."
            : "Next month. Viewing a future month for the first time populates it from the permanent weekly schedules as unconfirmed (hatched) entries. Navigation is limited to 6 months ahead."}>Next ▶</button>
        <button style={S.btnGhost} onClick={() => { setYear(now.getFullYear()); setMonth(now.getMonth()); }} title="Jump back to the current month">Today</button>
        <span style={{ fontSize: 13, color: "#6b7280", cursor: "help" }}
          title="This month's totals: open sessions across all branches, how many have cover (confirmed or unconfirmed), how many have none, and how many still contain unconfirmed placements awaiting a double-click.">
          {monthStats.open} open sessions · {monthStats.covered} covered · <b style={{ color: monthStats.uncovered ? "#dc2626" : "#059669" }}>{monthStats.uncovered} uncovered</b>
          {monthStats.unconfirmed > 0 && <> · <b style={{ color: "#92400e" }}>{monthStats.unconfirmed} unconfirmed</b></>}
        </span>
        <button
          style={{ ...S.btnGreen, opacity: confirmingAll ? 0.6 : monthProvisionals.length === 0 ? 0.7 : 1 }}
          disabled={confirmingAll}
          onClick={confirmAllMonth}
          title="This will automatically confirm any suggested assignments which were entered based on the pharmacist normal pattern — for this month only.">
          {confirmingAll ? "Confirming…" : `Confirm all${monthProvisionals.length ? ` (${monthProvisionals.length})` : ""}`}
        </button>

        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "help" }}
            title="Every THURSDAY at 06:00, each active pharmacist with an email address is sent their own schedule for the FOLLOWING week (Monday to Sunday) — only the days they are working, with unconfirmed placements marked. Pharmacists with no sessions that week receive nothing.">
            Auto email weekly schedule
            <select style={S.select} value={settings.autoEmailWeekly ? "yes" : "no"}
              onChange={e => saveSettings({ ...settings, autoEmailWeekly: e.target.value === "yes" })}>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </label>
          <button
            style={S.btn}
            onClick={() => setShowEmailSchedules(true)}
            title="This will cascade down the plan for each pharmacist involved: choose who to include and how many weeks ahead, then send each their personal schedule.">
            Email schedules now
          </button>
          <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "help" }}
            title="Every THURSDAY at 06:00, emails the organisation's manager address a 'Pharmacist cover report' for the FOLLOWING TWO WEEKS: either 'COVER NEEDED' with a list of every open session that has no pharmacist at all (unconfirmed placements count as cover), or 'all covered' confirming every session is filled. On by default.">
            <input type="checkbox" checked={settings.coverFailureEmail !== false}
              onChange={e => saveSettings({ ...settings, coverFailureEmail: e.target.checked })} />
            Send cover failure to manager
          </label>
          <button style={S.btnGhost} onClick={() => setShowEmailHistory(true)}
            title="Every email this rota has sent — schedules, circulations, booking confirmations and cover reports — with date, recipient and delivery status. Click an email to read its content.">
            Email history</button>
        </div>
      </div>

      {/* ---- Rota grid ---- */}
      <div style={S.gridWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={{ ...S.thDay, top: 0, zIndex: 4, position: "sticky" }}>Day</th>
              {members.map(m => <th key={m.pharmacyName} style={S.thPharm}>{displayName(m.pharmacyName, masked)}</th>)}
            </tr>
          </thead>
          <tbody>
            {days.map(day => {
              const isToday = day.dateStr === ymd(new Date());
              const status = dayStatus(day.dateStr);
              const conflicts = conflictedPids(day.dateStr);   // pids at 2+ sites this date
              const DAY_STATUS_BG = {
                conflict: "#fca5a5",   // red — same pharmacist at 2+ sites
                uncovered: "#fcd34d",  // amber — at least one open site with no cover
                ok: "#86efac",         // green — all sites covered, all different pharmacists
                none: day.dow === "Saturday" || day.dow === "Sunday" ? "#eef2ff" : "#f9fafb"
              };
              const DAY_STATUS_TITLE = {
                conflict: "CONFLICT — the same pharmacist is assigned to more than one site on this date.",
                uncovered: "At least one open site has no pharmacist assigned on this date.",
                ok: "All open sites are covered and every pharmacist is at only one site.",
                none: "All sites closed."
              };
              return (
                <tr key={day.dateStr}>
                  <th title={DAY_STATUS_TITLE[status] + (isToday ? " (today)" : "")}
                    style={{
                      ...S.thDay,
                      background: DAY_STATUS_BG[status],
                      boxShadow: isToday ? "inset 0 0 0 2px #2563eb" : "none"
                    }}>
                    {ordinal(day.dayNum)}&nbsp;&nbsp;{day.dow}
                  </th>
                  {members.map(m => {
                    const { status, entries } = cellInfo(m, day.dateStr);
                    const hasProvisional = entries.some(e => e.status === "provisional");
                    const cellNote = cells.get(cellKey(day.dateStr, m.pharmacyName))?.note || "";
                    return (
                      <td key={m.pharmacyName}
                        title={(status === "closed" ? "Closed"
                          : status === "uncovered" ? "Open — no cover assigned. Click to assign."
                          : hasProvisional ? "Hatched = unconfirmed placement from the permanent schedule. DOUBLE-CLICK to confirm, single click to edit."
                          : "Click to view / edit cover")
                          + (cellNote ? `\n\nNote: ${cellNote}` : "")}
                        onClick={() => status !== "closed" && clickCell(day.dateStr, m.pharmacyName)}
                        onDoubleClick={() => status !== "closed" && dblClickCell(day.dateStr, m.pharmacyName, entries)}
                        style={{
                          ...S.cellBase,
                          background: hasProvisional ? hatched(CELL_COLOURS[status]) : CELL_COLOURS[status],
                          cursor: status === "closed" ? "default" : "pointer"
                        }}>
                        {hasProvisional && <span style={S.provMark} title="Contains unconfirmed placements">?</span>}
                        {cellNote && <span style={{ position: "absolute", top: 1, right: 2, fontSize: 9, lineHeight: 1 }}
                          title={`Note: ${cellNote}`}>📝</span>}
                        {entries.map(({ pid, status: entryStatus }) => {
                          const p = byId[pid];
                          const isConflicted = conflicts.has(pid);
                          return (
                            <div key={pid}
                              title={isConflicted ? `${p ? p.name : "This pharmacist"} is assigned to more than one site on this date.` : undefined}
                              style={{
                                fontSize: 11.5, lineHeight: 1.25, whiteSpace: "nowrap",
                                overflow: "hidden", textOverflow: "ellipsis",
                                fontStyle: p && p.type === "Locum" ? "italic" : "normal",
                                fontWeight: p && p.type !== "Locum" ? 600 : 400,
                                opacity: entryStatus === "provisional" ? 0.75 : 1,
                                textDecoration: entryStatus === "provisional" ? "underline dashed" : "none",
                                background: isConflicted ? "#f87171" : "transparent",
                                color: isConflicted ? "#fff" : "inherit",
                                borderRadius: isConflicted ? 3 : 0,
                                padding: isConflicted ? "0 3px" : 0
                              }}>
                              {p ? displayName(p.name, masked) : "(deleted)"}
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ---- Popups ---- */}
      {openCell && (
        <CellPopup dateStr={openCell.dateStr} pharmacyName={openCell.pharmacyName}
          cells={cells} pharmacists={pharmacists} members={members}
          mutateCell={mutateCell} saveCellNote={saveCellNote} saveCellShifts={saveCellShifts}
          createPharmacist={createPharmacist}
          onToast={onToast} onClose={() => setOpenCell(null)} />
      )}
      {showList && (
        <PharmacistListPopup pharmacists={pharmacists} members={members}
          createPharmacist={createPharmacist} updatePharmacist={updatePharmacist}
          deletePharmacist={deletePharmacist} onClose={() => setShowList(false)} />
      )}
      {showCirculate && (
        <CirculatePopup pharmacists={pharmacists} members={members} cells={cells}
          uncoveredSessions={uncoveredSessionsCirculate} days={circulateDays}
          onToast={onToast} onClose={() => setShowCirculate(false)} />
      )}
      {showSummaries && (
        <MonthlySummariesPopup pharmacists={pharmacists} members={members} cells={cells}
          ensureRange={ensureRange} settings={settings} saveSettings={saveSettings}
          onClose={() => setShowSummaries(false)} />
      )}
      {showCircLog && <CirculationLogPopup onToast={onToast} onClose={() => setShowCircLog(false)} />}
      {showEmailSchedules && (
        <EmailSchedulesPopup pharmacists={pharmacists} members={members} cells={cells}
          ensureRange={ensureRange} onToast={onToast} onClose={() => setShowEmailSchedules(false)} />
      )}
      {showEmailHistory && <EmailHistoryPopup onToast={onToast} onClose={() => setShowEmailHistory(false)} />}
      {showHelp && <HelpPopup onClose={() => setShowHelp(false)} />}
      {toast && <div style={S.toast}>{toast}</div>}
    </div>
  );
}